"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AccountManagerType: () => AccountManagerType,
  ApplicationChatMode: () => ApplicationChatMode,
  ApplicationReminderType: () => ApplicationReminderType,
  ApplicationRoundStatus: () => ApplicationRoundStatus,
  ApplicationRoundType: () => ApplicationRoundType,
  ApplicationStatus: () => ApplicationStatus,
  ApprovalType: () => ApprovalType,
  AssessActivityType: () => AssessActivityType,
  AssessPlatformDifficulty: () => AssessPlatformDifficulty,
  AssessmentDuration: () => AssessmentDuration,
  AssignmentSubmissionType: () => AssignmentSubmissionType,
  AttemptStatus: () => AttemptStatus,
  AvailedInterviewType: () => AvailedInterviewType,
  BehaviouralFlagStatus: () => BehaviouralFlagStatus,
  BriedDebriefCallType: () => BriedDebriefCallType,
  CallLogsDispositions: () => CallLogsDispositions,
  CampusApplicationStatus: () => CampusApplicationStatus,
  CampusRoundStatus: () => CampusRoundStatus,
  CampusRoundType: () => CampusRoundType,
  CompanyNature: () => CompanyNature,
  CompanyOwnershipType: () => CompanyOwnershipType,
  CompanyType: () => CompanyType,
  ContestRewardTypes: () => ContestRewardTypes,
  ContestStatus: () => ContestStatus,
  CourseType: () => CourseType,
  CurrentWorkingStatus: () => CurrentWorkingStatus,
  DegreeType: () => DegreeType,
  DevelopmentRoleType: () => DevelopmentRoleType,
  DriveInviteeApplicationStatus: () => DriveInviteeApplicationStatus,
  DriveInviteeStatus: () => DriveInviteeStatus,
  DriveInviteeTestStatusType: () => DriveInviteeTestStatusType,
  DriveInviteeType: () => DriveInviteeType,
  DriveRoundType: () => DriveRoundType,
  EscalationLevel: () => EscalationLevel,
  FeatureFlagType: () => FeatureFlagType,
  GaugingCandidateStatus: () => GaugingCandidateStatus,
  GradeType: () => GradeType,
  HighestQualification: () => HighestQualification,
  InterviewFormatType: () => InterviewFormatType,
  InterviewPathType: () => InterviewPathType,
  JobseekerFormJobType: () => JobseekerFormJobType,
  JobseekerSubRole: () => JobseekerSubRole,
  LMSLinkingStatus: () => LMSLinkingStatus,
  MarketingPageStatus: () => MarketingPageStatus,
  MeetingJoineeStatus: () => MeetingJoineeStatus,
  MeetingStatus: () => MeetingStatus,
  MeetingSuccessStatus: () => MeetingSuccessStatus,
  MeetingType: () => MeetingType,
  MessageSenderType: () => MessageSenderType,
  NatureOfBusinessType: () => NatureOfBusinessType,
  NbfcDetailStatus: () => NbfcDetailStatus,
  OFFLINE_DRIVE_CITY: () => OFFLINE_DRIVE_CITY,
  OfflineDocumentsTypes: () => OfflineDocumentsTypes,
  OfflineDriveCandidateStatus: () => OfflineDriveCandidateStatus,
  OfflineTechStackType: () => OfflineTechStackType,
  OptOutReason: () => OptOutReason,
  PIFReviewStatusType: () => PIFReviewStatusType,
  PaymentStatus: () => PaymentStatus,
  PaymentType: () => PaymentType,
  PhoneVerificationStatus: () => PhoneVerificationStatus,
  PositionBucketType: () => PositionBucketType,
  PositionEducationRequirementType: () => PositionEducationRequirementType,
  PositionQualifiedFor: () => PositionQualifiedFor,
  PositionStatus: () => PositionStatus,
  PositionTitle: () => PositionTitle,
  PositionType: () => PositionType,
  PositionUserBehaviouralFlag: () => PositionUserBehaviouralFlag,
  PostgraduateDegreeTypes: () => PostgraduateDegreeTypes,
  PrepPlanBadgeStatus: () => PrepPlanBadgeStatus,
  ProctoringStatus: () => ProctoringStatus,
  ProfilePageTabs: () => ProfilePageTabs,
  QuestionDifficulty: () => QuestionDifficulty,
  QuestionTypes: () => QuestionTypes,
  Reason: () => Reason,
  RecommendedPath: () => RecommendedPath,
  RecordingStatus: () => RecordingStatus,
  RewardActivityType: () => RewardActivityType,
  RewardType: () => RewardType,
  RoundLabelType: () => RoundLabelType,
  RoundType: () => RoundType,
  ScoreType: () => ScoreType,
  ScreeningStatus: () => ScreeningStatus,
  SerriTemplateType: () => SerriTemplateType,
  SessionJoineeStatus: () => SessionJoineeStatus,
  SessionRecordingStatus: () => SessionRecordingStatus,
  SessionStatus: () => SessionStatus,
  SessionSuccessStatus: () => SessionSuccessStatus,
  SessionType: () => SessionType,
  SkillGroupType: () => SkillGroupType,
  SkillPriority: () => SkillPriority,
  SkillType: () => SkillType,
  SlackMessageHistoryErrorEnums: () => SlackMessageHistoryErrorEnums,
  SlackMessageHistoryStatusEnums: () => SlackMessageHistoryStatusEnums,
  SlackMessageTypeEnums: () => SlackMessageTypeEnums,
  SlackWorkspaceEnvironment: () => SlackWorkspaceEnvironment,
  SlackWorkspaceType: () => SlackWorkspaceType,
  Source: () => Source,
  SpecializationType: () => SpecializationType,
  StateCityTypes: () => StateCityTypes,
  StateFilterType: () => StateFilterType,
  Status: () => Status,
  SubRoundType: () => SubRoundType,
  SupportQuestionCategory: () => SupportQuestionCategory,
  SupportTicketStatus: () => SupportTicketStatus,
  TechStackType: () => TechStackType,
  TechStacksForPosition: () => TechStacksForPosition,
  TierType: () => TierType,
  TrackingContent: () => TrackingContent,
  TrackingType: () => TrackingType,
  TypeOfUsers: () => TypeOfUsers,
  UIApplicationCardState: () => UIApplicationCardState,
  UIApplicationTypeEnum: () => UIApplicationTypeEnum,
  UIPositionStatus: () => UIPositionStatus,
  UIRemarksDrawerType: () => UIRemarksDrawerType,
  UITrackingType: () => UITrackingType,
  UndergraduateDegreeTypes: () => UndergraduateDegreeTypes,
  UserCareerPathType: () => UserCareerPathType,
  UserExperienceLevelType: () => UserExperienceLevelType,
  UserISAStatus: () => UserISAStatus,
  UserJapEnrollmentStatus: () => UserJapEnrollmentStatus,
  UserJapEnrollmentType: () => UserJapEnrollmentType,
  UserPapStatus: () => UserPapStatus,
  UserPercentileBucket: () => UserPercentileBucket,
  UserPlacementTags: () => UserPlacementTags,
  UserRole: () => UserRole,
  VerificationType: () => VerificationType,
  VisibilityType: () => VisibilityType,
  VoteType: () => VoteType,
  WeekDay: () => WeekDay,
  WhatsappMessageType: () => WhatsappMessageType,
  WorkingMode: () => WorkingMode,
  YesOrNoEnum: () => YesOrNoEnum,
  matchedPercentileType: () => matchedPercentileType,
  skillsWeightageParameters: () => skillsWeightageParameters
});
module.exports = __toCommonJS(src_exports);

// src/user/user.interface.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["JOBSEEKER"] = "JobSeeker";
  UserRole2["EXPERIENCED_JOBSEEKER"] = "ExperiencedJobSeeker";
  UserRole2["MENTOR"] = "Mentor";
  UserRole2["SUPER_ADMIN"] = "SuperAdmin";
  UserRole2["ADMIN"] = "Admin";
  UserRole2["RECRUITER"] = "Recruiter";
  UserRole2["ACCOUNT_MANAGER"] = "AccountManager";
  UserRole2["SUPER_ACCOUNT_MANAGER"] = "SuperAccountManager";
  UserRole2["AI_INTERVIEWER"] = "AIInterviewer";
  UserRole2["ALUMNI_CONNECT"] = "AlumniConnect";
  UserRole2["UNIVERSITY_REPRESENTATIVE"] = "UniversityRepresentative";
  UserRole2["GUEST_JOBSEEKER"] = "GuestJobseeker";
  UserRole2["DRIVE_ADMIN"] = "DriveAdmin";
  UserRole2["SUPER_LEAD_GEN"] = "SuperLeadGen";
  UserRole2["LEAD_GEN"] = "LeadGen";
  return UserRole2;
})(UserRole || {});
var PhoneVerificationStatus = /* @__PURE__ */ ((PhoneVerificationStatus2) => {
  PhoneVerificationStatus2["Error"] = "Error";
  PhoneVerificationStatus2["Success"] = "Success";
  return PhoneVerificationStatus2;
})(PhoneVerificationStatus || {});
var AvailedInterviewType = /* @__PURE__ */ ((AvailedInterviewType2) => {
  AvailedInterviewType2["First"] = "First";
  AvailedInterviewType2["Second"] = "Second";
  AvailedInterviewType2["OneNoShow"] = "OneNoShow";
  return AvailedInterviewType2;
})(AvailedInterviewType || {});
var ScreeningStatus = /* @__PURE__ */ ((ScreeningStatus2) => {
  ScreeningStatus2["Requested"] = "Requested";
  ScreeningStatus2["Completed"] = "Completed";
  return ScreeningStatus2;
})(ScreeningStatus || {});
var TypeOfUsers = /* @__PURE__ */ ((TypeOfUsers2) => {
  TypeOfUsers2["FRESHER"] = "fresher";
  TypeOfUsers2["ASSESSMENT"] = "assessment";
  TypeOfUsers2["CAMPUS"] = "campus";
  TypeOfUsers2["DRIVE"] = "drive";
  return TypeOfUsers2;
})(TypeOfUsers || {});
var JobseekerSubRole = /* @__PURE__ */ ((JobseekerSubRole2) => {
  JobseekerSubRole2["MasaiStudent"] = "MasaiStudent";
  JobseekerSubRole2["MasaiTechInterns"] = "MasaiTechInterns";
  JobseekerSubRole2["MasaiYodha"] = "MasaiYodha";
  JobseekerSubRole2["CAP"] = "CAP";
  JobseekerSubRole2["CN"] = "CN";
  JobseekerSubRole2["MasaiAlum"] = "MasaiAlum";
  JobseekerSubRole2["LevelUpExternal"] = "LevelUpExternal";
  JobseekerSubRole2["MCL_LevelUp"] = "MCL_LevelUp";
  JobseekerSubRole2["Onwards"] = "Onwards";
  JobseekerSubRole2["CollegeStudents"] = "CollegeStudents";
  JobseekerSubRole2["Vector"] = "Vector";
  JobseekerSubRole2["Empower_Her"] = "Empower_Her";
  JobseekerSubRole2["Chitkara"] = "Chitkara";
  JobseekerSubRole2["IIT"] = "IIT";
  return JobseekerSubRole2;
})(JobseekerSubRole || {});
var UserPlacementTags = /* @__PURE__ */ ((UserPlacementTags2) => {
  UserPlacementTags2["Placed"] = "Placed";
  UserPlacementTags2["VerballyPlaced"] = "VerballyPlaced";
  UserPlacementTags2["Paused"] = "Paused";
  UserPlacementTags2["Available"] = "Available";
  UserPlacementTags2["Recovery"] = "Recovery";
  UserPlacementTags2["OutOfPLacement"] = "OutOfPLacement";
  UserPlacementTags2["PrePlacement"] = "PrePlacement";
  UserPlacementTags2["NotAvailable"] = "NotAvailable";
  UserPlacementTags2["AutoPaused"] = "AutoPaused";
  return UserPlacementTags2;
})(UserPlacementTags || {});
var LMSLinkingStatus = /* @__PURE__ */ ((LMSLinkingStatus2) => {
  LMSLinkingStatus2["STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
  LMSLinkingStatus2["STUDENT_CODE_SUCCESSFULLY_UPDATED"] = "STUDENT_CODE_SUCCESSFULLY_UPDATED";
  LMSLinkingStatus2["PHONE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "PHONE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
  LMSLinkingStatus2["ACCOUNT_SUCCESSFULLY_CREATED"] = "ACCOUNT_SUCCESSFULLY_CREATED";
  LMSLinkingStatus2["CREATION_FAILED_STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "CREATION_FAILED_STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
  return LMSLinkingStatus2;
})(LMSLinkingStatus || {});
var FeatureFlagType = /* @__PURE__ */ ((FeatureFlagType2) => {
  FeatureFlagType2["OFFLINE_DRIVE_PUSH_USER"] = "OFFLINE_DRIVE_PUSH_USER";
  return FeatureFlagType2;
})(FeatureFlagType || {});
var UserPercentileBucket = /* @__PURE__ */ ((UserPercentileBucket2) => {
  UserPercentileBucket2["TOP_ONE"] = "TOP_ONE";
  UserPercentileBucket2["TOP_TEN"] = "TOP_TEN";
  UserPercentileBucket2["TOP_TWENTY_FIVE"] = "TOP_TWENTY_FIVE";
  UserPercentileBucket2["TOP_FIFTY"] = "TOP_FIFTY";
  return UserPercentileBucket2;
})(UserPercentileBucket || {});
var UserExperienceLevelType = /* @__PURE__ */ ((UserExperienceLevelType2) => {
  UserExperienceLevelType2["FINAL_YEAR_STUDENT"] = "finalYearStudent";
  UserExperienceLevelType2["FRESHER"] = "fresher";
  UserExperienceLevelType2["OneToTwoYears"] = "oneToTwoYears";
  UserExperienceLevelType2["TwoPlusYears"] = "twoPlusYears";
  return UserExperienceLevelType2;
})(UserExperienceLevelType || {});
var UserCareerPathType = /* @__PURE__ */ ((UserCareerPathType2) => {
  UserCareerPathType2["SOFTWARE_DEVELOPMENT"] = "softwareDevelopment";
  UserCareerPathType2["DATA_ANALYTICS"] = "dataAnalytics";
  UserCareerPathType2["SDET"] = "sdet";
  UserCareerPathType2["TECH_SUPPORT"] = "techSupport";
  UserCareerPathType2["OPERATIONS"] = "operations";
  UserCareerPathType2["BD_EXECUTIVE"] = "bdExecutive";
  UserCareerPathType2["DEV_OPS"] = "devOps";
  UserCareerPathType2["MATH_ANNOTATIONS_EXPERT"] = "mathAnnotationsExpert";
  UserCareerPathType2["SITE_RELIABILITY_ENGINEER"] = "siteReliabilityEngineer";
  UserCareerPathType2["SALES"] = "sales";
  UserCareerPathType2["PRODUCT"] = "product";
  UserCareerPathType2["HUMAN_RESOURCES"] = "humanResources";
  UserCareerPathType2["MARKETING"] = "marketing";
  UserCareerPathType2["HASKELL"] = "haskell";
  UserCareerPathType2["REACT_NATIVE"] = "reactNative";
  UserCareerPathType2["AI_ENGINEER"] = "aiEngineer";
  return UserCareerPathType2;
})(UserCareerPathType || {});
var DevelopmentRoleType = /* @__PURE__ */ ((DevelopmentRoleType2) => {
  DevelopmentRoleType2["FRONTEND"] = "frontend";
  DevelopmentRoleType2["BACKEND"] = "backend";
  DevelopmentRoleType2["FULL_STACK"] = "fullStack";
  DevelopmentRoleType2["OTHER"] = "other";
  DevelopmentRoleType2["DATA_ANALYST"] = "dataAnalyst";
  DevelopmentRoleType2["DATA_SCIENTIST"] = "dataScientist";
  DevelopmentRoleType2["TWO_TO_FOUR_YEARS"] = "twoToFourYearsExperience";
  DevelopmentRoleType2["FOUR_PLUS_YEARS"] = "fourPlusYearsExperience";
  DevelopmentRoleType2["SALES_B2C"] = "salesB2C";
  DevelopmentRoleType2["SALES_B2B"] = "salesB2B";
  DevelopmentRoleType2["PRODUCT_MANAGER"] = "productManager";
  DevelopmentRoleType2["HR_MANAGER"] = "hrManager";
  DevelopmentRoleType2["DIGITAL_MARKETING"] = "digitalMarketing";
  DevelopmentRoleType2["SENIOR_QA_ENGINEER"] = "seniorQAEngineer";
  DevelopmentRoleType2["SENIOR_HASKELL_ENGINEER"] = "seniorHaskellEngineer";
  DevelopmentRoleType2["SENIOR_REACT_NATIVE_DEVELOPER"] = "seniorReactNativeDeveloper";
  return DevelopmentRoleType2;
})(DevelopmentRoleType || {});
var TechStackType = /* @__PURE__ */ ((TechStackType2) => {
  TechStackType2["MEAN"] = "mean";
  TechStackType2["PYTHON"] = "python";
  TechStackType2["MERN"] = "mern";
  TechStackType2["DJANGO"] = "django";
  TechStackType2["JAVA"] = "java";
  TechStackType2["NODE"] = "node";
  TechStackType2["REACT"] = "react";
  TechStackType2["SDET"] = "sdet";
  TechStackType2["DATA_ANALYTICS"] = "dataAnalytics";
  TechStackType2["ANGULAR"] = "angular";
  TechStackType2["VUE"] = "vue";
  TechStackType2["FLASK"] = "flask";
  TechStackType2["C_SHARP_ENGINEER"] = "csharpEngineer";
  TechStackType2["OTHER"] = "other";
  return TechStackType2;
})(TechStackType || {});
var UserPapStatus = /* @__PURE__ */ ((UserPapStatus2) => {
  UserPapStatus2["NEW_PAP"] = "New PAP";
  UserPapStatus2["NO_PAP"] = "No PAP";
  UserPapStatus2["OLD_PAP"] = "Old PAP";
  UserPapStatus2["PAP"] = "PAP";
  return UserPapStatus2;
})(UserPapStatus || {});
var AssessmentDuration = /* @__PURE__ */ ((AssessmentDuration2) => {
  AssessmentDuration2["THIRTY_MIN"] = "30 MINS";
  AssessmentDuration2["SIXTY_MIN"] = "60 MINS";
  AssessmentDuration2["NINETY_MIN"] = "90 MINS";
  return AssessmentDuration2;
})(AssessmentDuration || {});
var GaugingCandidateStatus = /* @__PURE__ */ ((GaugingCandidateStatus2) => {
  GaugingCandidateStatus2["OVERALL"] = "Overall";
  GaugingCandidateStatus2["THEORETICAL"] = "Theoretical";
  GaugingCandidateStatus2["PRACTICAL"] = "Practical";
  return GaugingCandidateStatus2;
})(GaugingCandidateStatus || {});
var skillsWeightageParameters = /* @__PURE__ */ ((skillsWeightageParameters2) => {
  skillsWeightageParameters2["REACT"] = "react";
  skillsWeightageParameters2["JAVA"] = "java";
  skillsWeightageParameters2["HTML"] = "html";
  skillsWeightageParameters2["MERN"] = "mern";
  skillsWeightageParameters2["CSS"] = "css";
  skillsWeightageParameters2["ALGORITHMS"] = "algorithms";
  skillsWeightageParameters2["DSA"] = "dsa";
  skillsWeightageParameters2["BACKEND"] = "backend";
  skillsWeightageParameters2["SOFT_SKILLS"] = "softSkills";
  skillsWeightageParameters2["SQL"] = "sql";
  return skillsWeightageParameters2;
})(skillsWeightageParameters || {});
var YesOrNoEnum = /* @__PURE__ */ ((YesOrNoEnum2) => {
  YesOrNoEnum2["Yes"] = "yes";
  YesOrNoEnum2["No"] = "no";
  return YesOrNoEnum2;
})(YesOrNoEnum || {});
var StateCityTypes = /* @__PURE__ */ ((StateCityTypes2) => {
  StateCityTypes2["Maharashtra"] = "Maharashtra";
  StateCityTypes2["Karnataka"] = "Karnataka";
  StateCityTypes2["TamilNadu"] = "Tamil Nadu";
  StateCityTypes2["UttarPradesh"] = "Uttar Pradesh";
  StateCityTypes2["WestBengal"] = "West Bengal";
  StateCityTypes2["Gujarat"] = "Gujarat";
  StateCityTypes2["Rajasthan"] = "Rajasthan";
  StateCityTypes2["MadhyaPradesh"] = "Madhya Pradesh";
  StateCityTypes2["Punjab"] = "Punjab";
  StateCityTypes2["Bihar"] = "Bihar";
  StateCityTypes2["Odisha"] = "Odisha";
  StateCityTypes2["Telangana"] = "Telangana";
  StateCityTypes2["AndhraPradesh"] = "Andhra Pradesh";
  StateCityTypes2["Kerala"] = "Kerala";
  StateCityTypes2["Haryana"] = "Haryana";
  StateCityTypes2["Jharkhand"] = "Jharkhand";
  StateCityTypes2["Chhattisgarh"] = "Chhattisgarh";
  StateCityTypes2["Assam"] = "Assam";
  StateCityTypes2["HimachalPradesh"] = "Himachal Pradesh";
  StateCityTypes2["JammuAndKashmir"] = "Jammu and Kashmir";
  StateCityTypes2["Uttarakhand"] = "Uttarakhand";
  StateCityTypes2["Tripura"] = "Tripura";
  StateCityTypes2["Meghalaya"] = "Meghalaya";
  StateCityTypes2["Manipur"] = "Manipur";
  StateCityTypes2["Nagaland"] = "Nagaland";
  StateCityTypes2["Mizoram"] = "Mizoram";
  StateCityTypes2["ArunachalPradesh"] = "Arunachal Pradesh";
  StateCityTypes2["Sikkim"] = "Sikkim";
  StateCityTypes2["Goa"] = "Goa";
  StateCityTypes2["Delhi"] = "Delhi";
  StateCityTypes2["Chandigarh"] = "Chandigarh";
  StateCityTypes2["Puducherry"] = "Puducherry";
  StateCityTypes2["Lakshadweep"] = "Lakshadweep";
  StateCityTypes2["DadraAndNagarHaveliAndDamanAndDiu"] = "Dadra and Nagar Haveli and Daman and Diu";
  StateCityTypes2["AndamanAndNicobarIslands"] = "Andaman and Nicobar Islands";
  StateCityTypes2["Ladakh"] = "Ladakh";
  return StateCityTypes2;
})(StateCityTypes || {});
var UndergraduateDegreeTypes = /* @__PURE__ */ ((UndergraduateDegreeTypes2) => {
  UndergraduateDegreeTypes2["Others"] = "Others";
  UndergraduateDegreeTypes2["BSc"] = "B.Sc.";
  UndergraduateDegreeTypes2["BTech"] = "B.Tech.";
  UndergraduateDegreeTypes2["BE"] = "B.E.";
  UndergraduateDegreeTypes2["BArch"] = "B.Arch.";
  UndergraduateDegreeTypes2["BCA"] = "BCA";
  UndergraduateDegreeTypes2["BCom"] = "B.Com.";
  UndergraduateDegreeTypes2["BBA"] = "BBA";
  UndergraduateDegreeTypes2["BBM"] = "BBM";
  UndergraduateDegreeTypes2["BMS"] = "BMS";
  UndergraduateDegreeTypes2["BA"] = "BA";
  UndergraduateDegreeTypes2["BFA"] = "BFA";
  UndergraduateDegreeTypes2["BVA"] = "BVA";
  UndergraduateDegreeTypes2["BDes"] = "B.Des.";
  UndergraduateDegreeTypes2["BJMC"] = "BJMC";
  UndergraduateDegreeTypes2["BSW"] = "BSW";
  UndergraduateDegreeTypes2["LLB"] = "LLB";
  UndergraduateDegreeTypes2["MBBS"] = "MBBS";
  UndergraduateDegreeTypes2["BDS"] = "BDS";
  UndergraduateDegreeTypes2["BAMS"] = "BAMS";
  UndergraduateDegreeTypes2["BHMS"] = "BHMS";
  UndergraduateDegreeTypes2["BPT"] = "BPT";
  UndergraduateDegreeTypes2["BOT"] = "BOT";
  UndergraduateDegreeTypes2["BPharm"] = "B.Pharm.";
  UndergraduateDegreeTypes2["BHM"] = "BHM";
  UndergraduateDegreeTypes2["BEd"] = "B.Ed.";
  UndergraduateDegreeTypes2["BLiSc"] = "B.Li.Sc.";
  UndergraduateDegreeTypes2["BPlan"] = "B.Plan.";
  UndergraduateDegreeTypes2["BVoc"] = "B.Voc.";
  UndergraduateDegreeTypes2["BASLP"] = "BASLP";
  UndergraduateDegreeTypes2["BALlb"] = "BA LLB";
  UndergraduateDegreeTypes2["BComLlb"] = "B.Com LLB";
  UndergraduateDegreeTypes2["BBALLb"] = "BBA LLB";
  return UndergraduateDegreeTypes2;
})(UndergraduateDegreeTypes || {});
var PostgraduateDegreeTypes = /* @__PURE__ */ ((PostgraduateDegreeTypes2) => {
  PostgraduateDegreeTypes2["Others"] = "Others";
  PostgraduateDegreeTypes2["MSc"] = "M.Sc.";
  PostgraduateDegreeTypes2["MTech"] = "M.Tech.";
  PostgraduateDegreeTypes2["ME"] = "M.E.";
  PostgraduateDegreeTypes2["MArch"] = "M.Arch.";
  PostgraduateDegreeTypes2["MCA"] = "MCA";
  PostgraduateDegreeTypes2["MCom"] = "M.Com.";
  PostgraduateDegreeTypes2["MBA"] = "MBA";
  PostgraduateDegreeTypes2["MA"] = "MA";
  PostgraduateDegreeTypes2["MFA"] = "MFA";
  PostgraduateDegreeTypes2["MDes"] = "M.Des.";
  PostgraduateDegreeTypes2["MJMC"] = "MJMC";
  PostgraduateDegreeTypes2["MSW"] = "MSW";
  PostgraduateDegreeTypes2["LLM"] = "LLM";
  PostgraduateDegreeTypes2["MD"] = "MD";
  PostgraduateDegreeTypes2["MS"] = "MS";
  PostgraduateDegreeTypes2["MDS"] = "MDS";
  PostgraduateDegreeTypes2["MPharm"] = "M.Pharm.";
  PostgraduateDegreeTypes2["MEd"] = "M.Ed.";
  PostgraduateDegreeTypes2["MLiSc"] = "M.Li.Sc.";
  PostgraduateDegreeTypes2["MPlan"] = "M.Plan.";
  PostgraduateDegreeTypes2["MVoc"] = "M.Voc.";
  PostgraduateDegreeTypes2["MASLP"] = "MASLP";
  return PostgraduateDegreeTypes2;
})(PostgraduateDegreeTypes || {});
var ScoreType = /* @__PURE__ */ ((ScoreType2) => {
  ScoreType2["PERCENTAGE"] = "percentage";
  ScoreType2["CGPA"] = "cgpa";
  ScoreType2["GPA"] = "gpa";
  return ScoreType2;
})(ScoreType || {});

// src/user/application.interface.ts
var ApplicationStatus = /* @__PURE__ */ ((ApplicationStatus2) => {
  ApplicationStatus2["OPENED_BY_EMPLOYER"] = "OpenedByEmployer";
  ApplicationStatus2["OPENED_BY_ADMIN"] = "OpenedByAdmin";
  ApplicationStatus2["APPLIED_BY_JOBSEEKER"] = "AppliedByJobSeeker";
  ApplicationStatus2["SHORTLISTED"] = "Shortlisted";
  ApplicationStatus2["REJECTED"] = "Rejected";
  ApplicationStatus2["AUTO_REJECTED"] = "AutoRejected";
  ApplicationStatus2["OFFER_REVOKED"] = "OfferRevoked";
  ApplicationStatus2["EXPIRED"] = "Expired";
  ApplicationStatus2["JOBSEEKER_OPTED_OUT"] = "JobSeekerOptedOut";
  ApplicationStatus2["PLACED"] = "Placed";
  ApplicationStatus2["VERBALLY_PLACED"] = "VerballyPlaced";
  ApplicationStatus2["CLOSED_BY_RECRUITER"] = "ClosedByRecruiter";
  ApplicationStatus2["CLOSED_BY_ADMIN"] = "ClosedByAdmin";
  ApplicationStatus2["INTERVIEW_SCHEDULED"] = "InterviewScheduled";
  ApplicationStatus2["ASSIGNMENT_IN_PROGRESS"] = "AssignmentInProgress";
  ApplicationStatus2["OFFER_ROLLED_OUT"] = "OfferRolledOut";
  ApplicationStatus2["OFFER_REJECTED"] = "OfferRejected";
  ApplicationStatus2["WAITING_FOR_RECRUITER_ACTION"] = "WaitingForRecruiterAction";
  ApplicationStatus2["QUALIFIED_ALL_ROUNDS"] = "QualifiedAllRounds";
  ApplicationStatus2["PENDING_FOR_OFFER_LETTER_APPROVAL"] = "PendingForOfferLetterApproval";
  ApplicationStatus2["PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL"] = "PendingForAssignmentSubmissionApproval";
  ApplicationStatus2["PENDING_FOR_OPT_OUT_APPROVAL"] = "PendingForOptOutApproval";
  ApplicationStatus2["CHANGED_OFFER_TERMS"] = "ChangedOfferTerms";
  ApplicationStatus2["PLACED_ELSEWHERE"] = "PlacedElseWhere";
  ApplicationStatus2["PENDING_FOR_ADMIN_APPROVAL"] = "PendingForAdminApproval";
  return ApplicationStatus2;
})(ApplicationStatus || {});
var ApplicationReminderType = /* @__PURE__ */ ((ApplicationReminderType2) => {
  ApplicationReminderType2["INACTIVE"] = "inactive";
  ApplicationReminderType2["EXPIRY"] = "expiry";
  ApplicationReminderType2["APPLIED_UNDER_REVIEW_AFTER_3_DAYS"] = "applied_under_review_3_days";
  ApplicationReminderType2["APPLIED_REJECT_AFTER_7_DAYS"] = "applied_reject_after_7_days";
  ApplicationReminderType2["SHORTLISTED_UNDER_REVIEW_AFTER_3_DAYS"] = "shortlisted_under_review_3_days";
  ApplicationReminderType2["SHORTLISTED_REJECT_AFTER_10_DAYS"] = "shortlisted_reject_after_10_days";
  return ApplicationReminderType2;
})(ApplicationReminderType || {});
var OptOutReason = /* @__PURE__ */ ((OptOutReason2) => {
  OptOutReason2["LOCATION_CONSTRAINTS"] = "location_constraints";
  OptOutReason2["LOWER_CTC"] = "lower_ctc";
  OptOutReason2["ACCEPTED_ANOTHER_OPPORTUNITY"] = "accepted_another_opportunity";
  OptOutReason2["TECH_STACK_ROLE_NOT_RELEVANT"] = "tech_stack_role_not_relevant";
  OptOutReason2["OTHER"] = "other";
  return OptOutReason2;
})(OptOutReason || {});
var UserISAStatus = /* @__PURE__ */ ((UserISAStatus2) => {
  UserISAStatus2["ABOVE_ISA"] = "Above ISA";
  UserISAStatus2["BELOW_ISA"] = "Below ISA";
  UserISAStatus2["NO_REVENUE"] = "No Revenue";
  UserISAStatus2["MORAT"] = "Morat";
  UserISAStatus2["ONLY_INTERN"] = "Only Intern";
  return UserISAStatus2;
})(UserISAStatus || {});
var UIApplicationTypeEnum = /* @__PURE__ */ ((UIApplicationTypeEnum2) => {
  UIApplicationTypeEnum2["MATCHED_APPLICATIONS"] = "matchedApplications";
  UIApplicationTypeEnum2["APPLIED_APPLICATIONS"] = "appliedApplications";
  UIApplicationTypeEnum2["ONGOING_APPLICATIONS"] = "ongoingApplications";
  UIApplicationTypeEnum2["CLOSED_APPLICATIONS"] = "closedApplications";
  return UIApplicationTypeEnum2;
})(UIApplicationTypeEnum || {});
var UIApplicationCardState = /* @__PURE__ */ ((UIApplicationCardState2) => {
  UIApplicationCardState2["MATCHED_CARD"] = "matched-card";
  UIApplicationCardState2["APPLIED_CARD"] = "applied-card";
  UIApplicationCardState2["INTERVIEW_ROUND_IN_PROGRESS_CARD"] = "interview-round-in-progress-card";
  UIApplicationCardState2["ASSIGNMENT_ROUND_IN_PROGRESS_CARD"] = "assignment-round-in-progress-card";
  UIApplicationCardState2["JOBSEEKER_OPTED_OUT_CARD"] = "jobseeker-opted-out-card";
  UIApplicationCardState2["OFFERED_CARD"] = "offered-card";
  UIApplicationCardState2["CLOSED_CARD"] = "closed-card";
  UIApplicationCardState2["SHORTLISTED_CARD"] = "shortlisted-card";
  UIApplicationCardState2["WAITING_FOR_RECRUITER_ACTION_CARD"] = "waiting-for-recruiter-action-card";
  UIApplicationCardState2["QUALIFIED_ALL_ROUNDS_CARD"] = "qualified-all-rounds-card";
  UIApplicationCardState2["PENDING_FOR_OFFER_LETTER_APPROVAL_CARD"] = "pending-for-offer-letter-approval-card";
  UIApplicationCardState2["PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL_CARD"] = "pending-for-assignment-submission-approval-card";
  UIApplicationCardState2["PENDING_FOR_OPT_OUT_APPROVAL_CARD"] = "pending-for-opt-out-approval-card";
  UIApplicationCardState2["PLACED_CARD"] = "placed-card";
  UIApplicationCardState2["REJECTED_CARD"] = "rejected-card";
  UIApplicationCardState2["CHANGED_OFFER_TERMS_CARD"] = "changed-offer-terms-card";
  UIApplicationCardState2["SELECTED_CARD"] = "selected-card";
  return UIApplicationCardState2;
})(UIApplicationCardState || {});
var UIRemarksDrawerType = /* @__PURE__ */ ((UIRemarksDrawerType2) => {
  UIRemarksDrawerType2["REQUEST_OFFER_CHANGES"] = "request-offer-changes";
  UIRemarksDrawerType2["REJECT_ASSIGNMENT"] = "reject-assignment";
  UIRemarksDrawerType2["REQUEST_CORRECTION_IN_ASSIGNMENT"] = "request-correction-in-assignment";
  UIRemarksDrawerType2["SEND_OFFER_LETTER_CHANGES"] = "send-offer-letter-changes";
  UIRemarksDrawerType2["SEND_OPT_OUT_OFFER_CHANGES"] = "send-opt-out-offer-changes";
  return UIRemarksDrawerType2;
})(UIRemarksDrawerType || {});

// src/user/profile.interface.ts
var CurrentWorkingStatus = /* @__PURE__ */ ((CurrentWorkingStatus2) => {
  CurrentWorkingStatus2["Studying"] = "Studying";
  CurrentWorkingStatus2["Working"] = "Working";
  CurrentWorkingStatus2["GraduatedNotWorking"] = "GraduatedNotWorking";
  return CurrentWorkingStatus2;
})(CurrentWorkingStatus || {});
var DegreeType = /* @__PURE__ */ ((DegreeType2) => {
  DegreeType2["School"] = "School (10th)";
  DegreeType2["HighSchool"] = "High School (12th)";
  DegreeType2["Bachelors"] = "Bachelors";
  DegreeType2["Masters"] = "Masters";
  DegreeType2["Diploma"] = "Diploma";
  DegreeType2["PostGraduateDiploma"] = "Post Graduate Diploma";
  DegreeType2["Doctorate"] = "Doctorate";
  return DegreeType2;
})(DegreeType || {});
var PositionEducationRequirementType = /* @__PURE__ */ ((PositionEducationRequirementType2) => {
  PositionEducationRequirementType2["AnyDegree"] = "No Degree Constraints";
  PositionEducationRequirementType2["AnyGraduates"] = "Graduate";
  PositionEducationRequirementType2["BCA_MCA"] = "BCA/MCA";
  PositionEducationRequirementType2["Btech"] = "B.Tech";
  PositionEducationRequirementType2["BtechWithCSE"] = "B.Tech (CS/IT)";
  return PositionEducationRequirementType2;
})(PositionEducationRequirementType || {});
var CourseType = /* @__PURE__ */ ((CourseType2) => {
  CourseType2["BTechBE"] = "B.Tech/B.E";
  CourseType2["BCA"] = "BCA";
  CourseType2["MCA"] = "MCA";
  CourseType2["MTech"] = "M.Tech";
  CourseType2["PGDCA"] = "PGDCA";
  CourseType2["BSc"] = "B.Sc";
  CourseType2["BPharm"] = "B.Pharm";
  CourseType2["MSc"] = "M.Sc";
  CourseType2["ITI"] = "ITI";
  CourseType2["BA"] = "B.A";
  CourseType2["BCom"] = "B.Com";
  CourseType2["MBA"] = "MBA";
  CourseType2["Diploma"] = "Diploma";
  CourseType2["BArch"] = "B.Arch";
  CourseType2["MCom"] = "M.COM";
  CourseType2["BBA"] = "BBA";
  CourseType2["LLB"] = "LLB";
  CourseType2["BElEd"] = "B.El.Ed";
  CourseType2["MA"] = "M.A";
  CourseType2["BachelorHotelManagement"] = "Bachelor in Hotel Management";
  CourseType2["HighSchoolGraduate"] = "12th Graduate";
  CourseType2["GraduationDropout"] = "Graduation Dropout";
  return CourseType2;
})(CourseType || {});
var SpecializationType = /* @__PURE__ */ ((SpecializationType2) => {
  SpecializationType2["ElectronicsInstrumentation"] = "Electronics & Instrumentation";
  SpecializationType2["Electrical"] = "Electrical";
  SpecializationType2["ElectricalElectronics"] = "Electrical & Electronics";
  SpecializationType2["Electronics"] = "Electronics";
  SpecializationType2["ECE"] = "ECE";
  SpecializationType2["CS"] = "CS";
  SpecializationType2["IT"] = "IT";
  SpecializationType2["Mathematics"] = "Mathematics";
  SpecializationType2["Others"] = "Others";
  SpecializationType2["Any"] = "Any";
  return SpecializationType2;
})(SpecializationType || {});
var GradeType = /* @__PURE__ */ ((GradeType2) => {
  GradeType2["Percentage"] = "Percentage (%)";
  GradeType2["GradePointAverage"] = "Grade Point Average (GPA)";
  return GradeType2;
})(GradeType || {});

// src/user/userEvaluation.interface.ts
var RecommendedPath = /* @__PURE__ */ ((RecommendedPath2) => {
  RecommendedPath2["PrepPlan"] = "PrepPlan";
  RecommendedPath2["JAP"] = "JAP";
  RecommendedPath2["MAP"] = "MAP";
  RecommendedPath2["Vector"] = "Vector";
  RecommendedPath2["MCL_1_Week"] = "MCL_1_Week";
  RecommendedPath2["MCL_1_Month"] = "MCL_1_Month";
  RecommendedPath2["Need_Improvement"] = "Need_Improvement";
  RecommendedPath2["Back_to_Masai"] = "Back_to_Masai";
  RecommendedPath2["Missed_One_Round"] = "Missed_One_Round";
  RecommendedPath2["Missed_Two_Rounds"] = "Missed_Two_Rounds";
  RecommendedPath2["Schedule_First_Round"] = "Schedule_First_Round";
  return RecommendedPath2;
})(RecommendedPath || {});

// src/user/userJapEnrollment.interface.ts
var UserJapEnrollmentStatus = /* @__PURE__ */ ((UserJapEnrollmentStatus2) => {
  UserJapEnrollmentStatus2["OFFERED"] = "Offered";
  UserJapEnrollmentStatus2["STARTED"] = "Started";
  UserJapEnrollmentStatus2["ENROLLED"] = "Enrolled";
  UserJapEnrollmentStatus2["DECLINED"] = "Declined";
  UserJapEnrollmentStatus2["EXPIRED"] = "Expired";
  return UserJapEnrollmentStatus2;
})(UserJapEnrollmentStatus || {});
var UserJapEnrollmentType = /* @__PURE__ */ ((UserJapEnrollmentType2) => {
  UserJapEnrollmentType2["JAP"] = "JAP";
  UserJapEnrollmentType2["MAP"] = "MAP";
  return UserJapEnrollmentType2;
})(UserJapEnrollmentType || {});

// src/user/userVerification.interface.ts
var VerificationType = /* @__PURE__ */ ((VerificationType2) => {
  VerificationType2["PHONE"] = "Phone";
  VerificationType2["EMAIL"] = "Email";
  return VerificationType2;
})(VerificationType || {});

// src/user/interviewPath.interface.ts
var InterviewPathType = /* @__PURE__ */ ((InterviewPathType2) => {
  InterviewPathType2["Paid"] = "Paid";
  InterviewPathType2["Free"] = "Free";
  return InterviewPathType2;
})(InterviewPathType || {});

// src/user/screeningFeedback.interface.ts
var Reason = /* @__PURE__ */ ((Reason2) => {
  Reason2["DNP"] = "Did Not Pickup";
  Reason2["SwitchedOffOrNotReachable"] = "Switched Off/Not Reachable";
  Reason2["WrongNumber"] = "Wrong Number";
  Reason2["NumberBusy"] = "Number Busy";
  Reason2["CallRejected"] = "Call Rejected";
  Reason2["NumberNotPresent"] = "Number Not Present";
  Reason2["UserAskedToCallBackLater"] = "User asked to call back later";
  Reason2["UserNotInterested"] = "User mentioned that he/she is not interested to give the screening round";
  return Reason2;
})(Reason || {});

// src/user/applicationRound.interface.ts
var ApplicationRoundStatus = /* @__PURE__ */ ((ApplicationRoundStatus2) => {
  ApplicationRoundStatus2["NotStarted"] = "NotStarted";
  ApplicationRoundStatus2["Started"] = "Started";
  ApplicationRoundStatus2["Initiated"] = "Initiated";
  ApplicationRoundStatus2["PendingForSubmissionApproval"] = "PendingForSubmissionApproval";
  ApplicationRoundStatus2["Submitted"] = "Submitted";
  ApplicationRoundStatus2["Rejected"] = "Rejected";
  ApplicationRoundStatus2["Skipped"] = "Skipped";
  ApplicationRoundStatus2["Qualified"] = "Qualified";
  ApplicationRoundStatus2["Cancelled"] = "Cancelled";
  ApplicationRoundStatus2["Rescheduled"] = "Rescheduled";
  ApplicationRoundStatus2["RequestedForReschedule"] = "RequestedForReschedule";
  ApplicationRoundStatus2["RequestedForCancellation"] = "RequestedForCancellation";
  ApplicationRoundStatus2["JobseekerOptedOut"] = "JobseekerOptedOut";
  ApplicationRoundStatus2["PlacedElseWhere"] = "PlacedElseWhere";
  return ApplicationRoundStatus2;
})(ApplicationRoundStatus || {});
var ApplicationRoundType = /* @__PURE__ */ ((ApplicationRoundType2) => {
  ApplicationRoundType2["Assignment"] = "Assignment";
  ApplicationRoundType2["Interview"] = "Interview";
  ApplicationRoundType2["OnlineTest"] = "OnlineTest";
  return ApplicationRoundType2;
})(ApplicationRoundType || {});
var AssignmentSubmissionType = /* @__PURE__ */ ((AssignmentSubmissionType2) => {
  AssignmentSubmissionType2["Link"] = "Link";
  AssignmentSubmissionType2["File"] = "File";
  AssignmentSubmissionType2["Both"] = "Both";
  AssignmentSubmissionType2["Other"] = "Other";
  return AssignmentSubmissionType2;
})(AssignmentSubmissionType || {});
var ApplicationChatMode = /* @__PURE__ */ ((ApplicationChatMode2) => {
  ApplicationChatMode2["Whatsapp"] = "Whatsapp";
  ApplicationChatMode2["Email"] = "Email";
  ApplicationChatMode2["Both"] = "Both";
  return ApplicationChatMode2;
})(ApplicationChatMode || {});
var RoundLabelType = /* @__PURE__ */ ((RoundLabelType2) => {
  RoundLabelType2["Screening"] = "Screening";
  RoundLabelType2["Coding_Test"] = "Coding_Test";
  RoundLabelType2["Take_Home_Assignment"] = "Take_Home_Assignment";
  RoundLabelType2["Technical_Discussion"] = "Technical_Discussion";
  RoundLabelType2["Cultural_Fit_Round"] = "Cultural_Fit_Round";
  RoundLabelType2["CXO_Discussion"] = "CXO_Discussion";
  return RoundLabelType2;
})(RoundLabelType || {});
var ApprovalType = /* @__PURE__ */ ((ApprovalType2) => {
  ApprovalType2["AssignmentSubmission"] = "AssignmentSubmission";
  ApprovalType2["OfferLetter"] = "OfferLetter";
  ApprovalType2["OfferLetterRejection"] = "OfferLetterRejection";
  ApprovalType2["MeetingRescheduleOrCancel"] = "MeetingRescheduleOrCancel";
  ApprovalType2["JobseekerOptOut"] = "JobseekerOptOut";
  ApprovalType2["Chat"] = "Chat";
  return ApprovalType2;
})(ApprovalType || {});

// src/profile/profile.interface.ts
var ProfilePageTabs = /* @__PURE__ */ ((ProfilePageTabs2) => {
  ProfilePageTabs2["Stats"] = "Stats";
  ProfilePageTabs2["Profile"] = "Profile";
  ProfilePageTabs2["Recordings"] = "Recordings";
  return ProfilePageTabs2;
})(ProfilePageTabs || {});
var SubRoundType = /* @__PURE__ */ ((SubRoundType2) => {
  SubRoundType2["Javaandspring"] = "JAVAANDSPRING";
  SubRoundType2["Mern"] = "MERN";
  SubRoundType2["Nodeandexpress"] = "NODEANDEXPRESS";
  SubRoundType2["Pythonanddjango"] = "PYTHONANDDJANGO";
  SubRoundType2["Pythonandflask"] = "PYTHONANDFLASK";
  SubRoundType2["Sdet"] = "SDET";
  SubRoundType2["React"] = "REACT";
  SubRoundType2["DA"] = "DATAANALYTICS";
  return SubRoundType2;
})(SubRoundType || {});

// src/userAvailability/userAvailability.interface.ts
var WeekDay = /* @__PURE__ */ ((WeekDay2) => {
  WeekDay2["Friday"] = "Friday";
  WeekDay2["Monday"] = "Monday";
  WeekDay2["Saturday"] = "Saturday";
  WeekDay2["Sunday"] = "Sunday";
  WeekDay2["Thursday"] = "Thursday";
  WeekDay2["Tuesday"] = "Tuesday";
  WeekDay2["Wednesday"] = "Wednesday";
  return WeekDay2;
})(WeekDay || {});

// src/interviewAssessmentTemplate/interviewAssessmentTemplate.interface.ts
var RoundType = /* @__PURE__ */ ((RoundType2) => {
  RoundType2["DSA"] = "Dsa";
  RoundType2["DSA_OLD"] = "DSA";
  RoundType2["Development"] = "Development";
  RoundType2["HLD"] = "HLD";
  RoundType2["LLD"] = "LLD";
  return RoundType2;
})(RoundType || {});

// src/company/company.interface.ts
var CompanyType = /* @__PURE__ */ ((CompanyType2) => {
  CompanyType2["LARGE_ENTERPRISE"] = "LargeEnterprise";
  CompanyType2["MEDIUM_ENTERPRISE"] = "MediumEnterprise";
  CompanyType2["SMALL_ENTERPRISE"] = "SmallEnterprise";
  CompanyType2["PRE_SEED_OR_BOOTSTRAP_OR_SEED_FUNDED_STARTUP"] = "PreSeedOrBootstrapOrSeedFundedStartup";
  CompanyType2["SERIES_AB_FUNDED_STARTUP"] = "SeriesAbFundedStartup";
  CompanyType2["SONICORN_OR_UNICORN_STARTUP"] = "SonicornOrUnicornStartup";
  return CompanyType2;
})(CompanyType || {});
var CompanyNature = /* @__PURE__ */ ((CompanyNature2) => {
  CompanyNature2["SERVICE"] = "Service";
  CompanyNature2["PRODUCT"] = "Product";
  return CompanyNature2;
})(CompanyNature || {});
var AccountManagerType = /* @__PURE__ */ ((AccountManagerType2) => {
  AccountManagerType2["Primary"] = "Primary";
  AccountManagerType2["Secondary"] = "Secondary";
  AccountManagerType2["LeadGen"] = "LeadGen";
  AccountManagerType2["PrepCoach"] = "PrepCoach";
  return AccountManagerType2;
})(AccountManagerType || {});
var CompanyOwnershipType = /* @__PURE__ */ ((CompanyOwnershipType2) => {
  CompanyOwnershipType2["Private"] = "Private";
  CompanyOwnershipType2["Public"] = "Public";
  return CompanyOwnershipType2;
})(CompanyOwnershipType || {});
var NatureOfBusinessType = /* @__PURE__ */ ((NatureOfBusinessType2) => {
  NatureOfBusinessType2["B2B"] = "B2B";
  NatureOfBusinessType2["B2C"] = "B2C";
  return NatureOfBusinessType2;
})(NatureOfBusinessType || {});

// src/company/position.interface.ts
var WorkingMode = /* @__PURE__ */ ((WorkingMode2) => {
  WorkingMode2["INTERNSHIP"] = "Internship";
  WorkingMode2["FULL_TIME"] = "FullTime";
  WorkingMode2["INTERNSHIP_TO_FULL_TIME"] = "InternshipToFullTime";
  return WorkingMode2;
})(WorkingMode || {});
var PositionQualifiedFor = /* @__PURE__ */ ((PositionQualifiedFor2) => {
  PositionQualifiedFor2["MASAI_1"] = "Masai 1";
  PositionQualifiedFor2["ALUMNI"] = "Alumni";
  PositionQualifiedFor2["CAP"] = "CAP";
  return PositionQualifiedFor2;
})(PositionQualifiedFor || {});
var BriedDebriefCallType = /* @__PURE__ */ ((BriedDebriefCallType2) => {
  BriedDebriefCallType2["BRIEF"] = "Brief";
  BriedDebriefCallType2["DEBRIEF"] = "Debrief";
  return BriedDebriefCallType2;
})(BriedDebriefCallType || {});
var PositionTitle = /* @__PURE__ */ ((PositionTitle2) => {
  PositionTitle2["SDE_ONE"] = "SDE_ONE";
  PositionTitle2["SDE_TWO"] = "SDE_TWO";
  PositionTitle2["SDE_THREE"] = "SDE_THREE";
  PositionTitle2["SENIOR_SOFTWARE_ENGINEER"] = "SENIOR_SOFTWARE_ENGINEER";
  PositionTitle2["BACKEND_ENGINEER"] = "BACKEND_ENGINEER";
  PositionTitle2["FRONTEND_ENGINEER"] = "FRONTEND_ENGINEER";
  PositionTitle2["FULL_STACK_ENGINEER"] = "FULL_STACK_ENGINEER";
  PositionTitle2["TECH_LEAD"] = "TECH_LEAD";
  PositionTitle2["ASSOCIATE_SOFTWARE_ENGINEER"] = "ASSOCIATE_SOFTWARE_ENGINEER";
  PositionTitle2["SOFTWARE_ENGINEER"] = "SOFTWARE_ENGINEER";
  PositionTitle2["GRADUATE_ENGINEER_TRAINEE"] = "GRADUATE_ENGINEER_TRAINEE";
  PositionTitle2["ENGINEERING_LEAD"] = "ENGINEERING_LEAD";
  PositionTitle2["ENGINEERING_MANAGER"] = "ENGINEERING_MANAGER";
  PositionTitle2["LEAD_DEVELOPER"] = "LEAD_DEVELOPER";
  PositionTitle2["JUNIOR_SOFTWARE_TESTER"] = "JUNIOR_SOFTWARE_TESTER";
  PositionTitle2["JUNIOR_QA_TESTER"] = "JUNIOR_QA_TESTER";
  PositionTitle2["QA_TESTER"] = "QA_TESTER";
  PositionTitle2["TEST_ANALYST"] = "TEST_ANALYST";
  PositionTitle2["SOFTWARE_TESTER"] = "SOFTWARE_TESTER";
  PositionTitle2["AUTOMATION_ENGINEER"] = "AUTOMATION_ENGINEER";
  PositionTitle2["QA_ENGINEER"] = "QA_ENGINEER";
  PositionTitle2["MANUAL_TESTER"] = "MANUAL_TESTER";
  PositionTitle2["DATA_ANALYST"] = "DATA_ANALYST";
  PositionTitle2["BUSINESS_ANALYST"] = "BUSINESS_ANALYST";
  PositionTitle2["MIS_EXECUTIVE"] = "MIS_EXECUTIVE";
  PositionTitle2["DATA_SCIENTIST"] = "DATA_SCIENTIST";
  PositionTitle2["INSTRUCTIONAL_ASSOCIATE"] = "INSTRUCTIONAL_ASSOCIATE";
  PositionTitle2["INSTRUCTIONAL_ASSOCIATE_DA"] = "INSTRUCTIONAL_ASSOCIATE_DA";
  PositionTitle2["TAG_IMPLEMENTATION"] = "Tag Implementation";
  PositionTitle2["CUSTOMER_SUPPORT_ENGINEER"] = "CUSTOMER_SUPPORT_ENGINEER";
  PositionTitle2["E_COMMERCE_OPERATIONS_ANALYST"] = "E-commerce Operations Analyst";
  PositionTitle2["TECH_SUPPORT"] = "TECH_SUPPORT";
  PositionTitle2["SOLUTION_ENGINEER"] = "SOLUTION_ENGINEER";
  PositionTitle2["MENTOR_ENGINEER"] = "MENTOR_ENGINEER";
  PositionTitle2["ML_ENGINEER"] = "ML_ENGINEER";
  PositionTitle2["AI_DEVELOPER"] = "AI_DEVELOPER";
  PositionTitle2["PROMPT_ENGINEER"] = "PROMPT_ENGINEER";
  PositionTitle2["OPERATION_EXECUTIVE"] = "OPERATION_EXECUTIVE";
  PositionTitle2["EVENTS_EXECUTION"] = "EVENTS_EXECUTION";
  PositionTitle2["EMAILS_EXECUTION"] = "EMAILS_EXECUTION";
  PositionTitle2["CONTENT_PUBLISHER"] = "CONTENT_PUBLISHER";
  PositionTitle2["SALES"] = "SALES";
  PositionTitle2["MARKETING"] = "MARKETING";
  PositionTitle2["OPERATIONS"] = "OPERATIONS";
  PositionTitle2["MANAGEMENT_TRAINEE"] = "MANAGEMENT_TRAINEE";
  PositionTitle2["AI_ENGINEER"] = "AI_ENGINEER";
  PositionTitle2["LLM_ENGINEER"] = "LLM_ENGINEER";
  PositionTitle2["RESEARCH_ANALYST_INTERN"] = "RESEARCH_ANALYST_INTERN";
  PositionTitle2["DIGITAL_MARKETING"] = "DIGITAL_MARKETING";
  PositionTitle2["DOT_NET_DEVELOPER"] = "DOT_NET_DEVELOPER";
  PositionTitle2["CONTENT_CREATOR"] = "CONTENT_CREATOR";
  PositionTitle2["SOCIAL_MEDIA_EXECUTIVE"] = "SOCIAL_MEDIA_EXECUTIVE";
  PositionTitle2["DATA_ENGINEER"] = "DATA_ENGINEER";
  return PositionTitle2;
})(PositionTitle || {});
var PositionType = /* @__PURE__ */ ((PositionType2) => {
  PositionType2["REMOTE"] = "Remote";
  PositionType2["HYBRID"] = "Hybrid";
  PositionType2["OFFICE"] = "Office";
  return PositionType2;
})(PositionType || {});
var PositionStatus = /* @__PURE__ */ ((PositionStatus2) => {
  PositionStatus2["OPEN"] = "Open";
  PositionStatus2["CLOSED"] = "Closed";
  PositionStatus2["MY"] = "My";
  return PositionStatus2;
})(PositionStatus || {});
var UIPositionStatus = /* @__PURE__ */ ((UIPositionStatus2) => {
  UIPositionStatus2["SELF"] = "Self";
  UIPositionStatus2["ACTIVE"] = "Active";
  UIPositionStatus2["ALL_COMPANIES"] = "All_Companies";
  return UIPositionStatus2;
})(UIPositionStatus || {});
var VisibilityType = /* @__PURE__ */ ((VisibilityType2) => {
  VisibilityType2["OPENTOALL"] = "OpenToAll";
  VisibilityType2["PRIVATE"] = "Private";
  return VisibilityType2;
})(VisibilityType || {});
var InterviewFormatType = /* @__PURE__ */ ((InterviewFormatType2) => {
  InterviewFormatType2["ONLINE"] = "Online";
  InterviewFormatType2["HYBRID"] = "Hybrid";
  InterviewFormatType2["INPERSON"] = "InPerson";
  return InterviewFormatType2;
})(InterviewFormatType || {});
var PositionUserBehaviouralFlag = /* @__PURE__ */ ((PositionUserBehaviouralFlag2) => {
  PositionUserBehaviouralFlag2["RejectedOffer"] = "RejectedOffer";
  PositionUserBehaviouralFlag2["Plagiarism"] = "Plagiarism";
  PositionUserBehaviouralFlag2["MissedInterview"] = "MissedInterview";
  PositionUserBehaviouralFlag2["DidNotSubmitAssignment"] = "DidNotSubmitAssignment";
  PositionUserBehaviouralFlag2["MissingInAction"] = "MissingInAction";
  PositionUserBehaviouralFlag2["MissedBrief"] = "MissedBrief";
  PositionUserBehaviouralFlag2["MissedDebrief"] = "MissedDebrief";
  PositionUserBehaviouralFlag2["NotProvidingAvailability"] = "NotProvidingAvailability";
  PositionUserBehaviouralFlag2["UninformedDepartureFromCompany"] = "UninformedDepartureFromCompany";
  PositionUserBehaviouralFlag2["BadConductDuringInterviewOrMasaiEmployee"] = "BadConductDuringInterviewOrMasaiEmployee";
  PositionUserBehaviouralFlag2["DirectlyNegotiatingWithCompany"] = "DirectlyNegotiatingWithCompany";
  PositionUserBehaviouralFlag2["IntentionalUnderPerformance"] = "IntentionalUnderPerformance";
  return PositionUserBehaviouralFlag2;
})(PositionUserBehaviouralFlag || {});
var BehaviouralFlagStatus = /* @__PURE__ */ ((BehaviouralFlagStatus2) => {
  BehaviouralFlagStatus2["PENDING"] = "pending";
  BehaviouralFlagStatus2["APPROVED"] = "approved";
  BehaviouralFlagStatus2["REJECTED"] = "rejected";
  return BehaviouralFlagStatus2;
})(BehaviouralFlagStatus || {});
var TechStacksForPosition = /* @__PURE__ */ ((TechStacksForPosition2) => {
  TechStacksForPosition2["MERN"] = "MERN";
  TechStacksForPosition2["JAVA"] = "JAVA";
  TechStacksForPosition2["NodeJs"] = "NodeJs";
  TechStacksForPosition2["Vanilla_Javascript"] = "Vanilla_Javascript";
  TechStacksForPosition2["Python_Django"] = "Python_Django";
  TechStacksForPosition2["Python_Flask"] = "Python_Flask";
  TechStacksForPosition2["React_and_Java"] = "React_and_Java";
  TechStacksForPosition2["ReactJs"] = "ReactJs";
  TechStacksForPosition2["Java_and_Springboot"] = "Java_and_Springboot";
  TechStacksForPosition2["Tech_Agnostic"] = "Tech_Agnostic";
  TechStacksForPosition2["SDET"] = "SDET";
  TechStacksForPosition2["DATA_ANALYTICS"] = "DATA_ANALYTICS";
  TechStacksForPosition2["NON_TECH"] = "NON_TECH";
  TechStacksForPosition2["AI_ENGINEER"] = "AI";
  TechStacksForPosition2["Python"] = "Python";
  TechStacksForPosition2["R"] = "R";
  TechStacksForPosition2["MATLAB"] = "MATLAB";
  TechStacksForPosition2["Excel"] = "Excel";
  TechStacksForPosition2["SQL"] = "SQL";
  TechStacksForPosition2["PowerBI"] = "PowerBI";
  TechStacksForPosition2["Tableau"] = "Tableau";
  TechStacksForPosition2["DIGITAL_MARKETING"] = "Digital_Marketing";
  TechStacksForPosition2["DOT_NET"] = "Dot_Net";
  TechStacksForPosition2["CONTENT_CREATOR"] = "CONTENT_CREATOR";
  TechStacksForPosition2["SOCIAL_MEDIA_EXECUTIVE"] = "SOCIAL_MEDIA_EXECUTIVE";
  TechStacksForPosition2["DATA_ENGINEER"] = "DATA_ENGINEER";
  return TechStacksForPosition2;
})(TechStacksForPosition || {});
var MarketingPageStatus = /* @__PURE__ */ ((MarketingPageStatus2) => {
  MarketingPageStatus2["CONFIRMED"] = "Confirmed";
  MarketingPageStatus2["PENDING"] = "Pending";
  return MarketingPageStatus2;
})(MarketingPageStatus || {});
var TierType = /* @__PURE__ */ ((TierType2) => {
  TierType2["TIER_ONE"] = "Tier1";
  TierType2["TIER_TWO"] = "Tier2";
  TierType2["TIER_THREE"] = "Tier3";
  TierType2["TIER_FOUR"] = "Tier4";
  return TierType2;
})(TierType || {});
var StateFilterType = /* @__PURE__ */ ((StateFilterType2) => {
  StateFilterType2["POSITION_STATE"] = "PositionState";
  StateFilterType2["NEIGHBHOUR_STATES"] = "NeighbourStates";
  StateFilterType2["REGION_STATES"] = "RegionStates";
  return StateFilterType2;
})(StateFilterType || {});

// src/company/scrapedPosition.interface.ts
var PositionBucketType = /* @__PURE__ */ ((PositionBucketType2) => {
  PositionBucketType2["FrontendEngineer"] = "FrontendEngineer";
  PositionBucketType2["BackendEngineerNode"] = "BackendEngineerNode";
  PositionBucketType2["BackendEngineerJava"] = "BackendEngineerJava";
  PositionBucketType2["FullStackEngineerMERN"] = "FullStackEngineerMERN";
  PositionBucketType2["DataAnalyst"] = "DataAnalyst";
  PositionBucketType2["SDET"] = "SDET";
  return PositionBucketType2;
})(PositionBucketType || {});

// src/assesment/assessment.interface.ts
var AssessPlatformDifficulty = /* @__PURE__ */ ((AssessPlatformDifficulty2) => {
  AssessPlatformDifficulty2["low"] = "low";
  AssessPlatformDifficulty2["medium"] = "medium";
  AssessPlatformDifficulty2["high"] = "high";
  return AssessPlatformDifficulty2;
})(AssessPlatformDifficulty || {});

// src/assesment/question.interface.ts
var QuestionTypes = /* @__PURE__ */ ((QuestionTypes2) => {
  QuestionTypes2["int"] = "int";
  QuestionTypes2["fitb"] = "fitb";
  QuestionTypes2["mcsc"] = "mcsc";
  QuestionTypes2["mcmc"] = "mcmc";
  QuestionTypes2["video"] = "video";
  QuestionTypes2["floatRange"] = "floatRange";
  QuestionTypes2["code"] = "coding";
  QuestionTypes2["subjective"] = "subjective";
  return QuestionTypes2;
})(QuestionTypes || {});

// src/skill/skill.interface.ts
var SkillType = /* @__PURE__ */ ((SkillType2) => {
  SkillType2["TOPIC"] = "Topic";
  SkillType2["SKILL"] = "Skill";
  return SkillType2;
})(SkillType || {});
var SkillGroupType = /* @__PURE__ */ ((SkillGroupType2) => {
  SkillGroupType2["TECHNICAL_SKILLS"] = "Technical_Skills";
  SkillGroupType2["THEORETICAL_SKILLS"] = "Theoretical_Knowledge";
  SkillGroupType2["SOFT_SKILLS"] = "Soft_Skills";
  SkillGroupType2["APTITUDE_SKILLS"] = "Aptitude_Skills";
  return SkillGroupType2;
})(SkillGroupType || {});
var SkillPriority = /* @__PURE__ */ ((SkillPriority2) => {
  SkillPriority2["PRIMARY"] = "Primary";
  SkillPriority2["SECONDARY"] = "Secondary";
  return SkillPriority2;
})(SkillPriority || {});

// src/meeting/meeting.interface.ts
var MeetingStatus = /* @__PURE__ */ ((MeetingStatus2) => {
  MeetingStatus2["SCHEDULED"] = "Scheduled";
  MeetingStatus2["STARTED"] = "Started";
  MeetingStatus2["COMPLETED"] = "Completed";
  MeetingStatus2["CANCELLED"] = "Cancelled";
  MeetingStatus2["RESCHEDULED"] = "Rescheduled";
  MeetingStatus2["ERRORED"] = "Errored";
  MeetingStatus2["MENTORCANCELLED"] = "MentorCancelled";
  MeetingStatus2["JOBSEEKERCANCELLED"] = "JobseekerCancelled";
  MeetingStatus2["ADMINCANCELLED"] = "AdminCancelled";
  MeetingStatus2["MENTORRESCHEDULED"] = "MentorRescheduled";
  MeetingStatus2["ADMINRESCHEDULED"] = "AdminRescheduled";
  MeetingStatus2["JOBSEEKERRESCHEDULED"] = "JobseekerRescheduled";
  MeetingStatus2["JOBSEEKERNOSHOW"] = "JobseekerNoShow";
  MeetingStatus2["MENTORNOSHOW"] = "MentorNoShow";
  MeetingStatus2["PENDING"] = "Pending";
  MeetingStatus2["PARTIALLYCOMPLETED"] = "PartiallyCompleted";
  MeetingStatus2["INVITED"] = "Invited";
  return MeetingStatus2;
})(MeetingStatus || {});
var MeetingSuccessStatus = /* @__PURE__ */ ((MeetingSuccessStatus2) => {
  MeetingSuccessStatus2["SUCCESSFUL"] = "Successful";
  MeetingSuccessStatus2["PARTIALLYSUCCESSFUL"] = "PartiallySuccessful";
  MeetingSuccessStatus2["UNSUCCESSFUL"] = "Unsuccessful";
  return MeetingSuccessStatus2;
})(MeetingSuccessStatus || {});
var MeetingType = /* @__PURE__ */ ((MeetingType2) => {
  MeetingType2["Interview"] = "Interview";
  MeetingType2["Assessment"] = "Assessment";
  return MeetingType2;
})(MeetingType || {});
var ProctoringStatus = /* @__PURE__ */ ((ProctoringStatus2) => {
  ProctoringStatus2["High"] = "High";
  ProctoringStatus2["Medium"] = "Medium";
  ProctoringStatus2["Low"] = "Low";
  ProctoringStatus2["Pending"] = "Pending";
  return ProctoringStatus2;
})(ProctoringStatus || {});

// src/meeting/meetingLogs.interface.ts
var MeetingJoineeStatus = /* @__PURE__ */ ((MeetingJoineeStatus2) => {
  MeetingJoineeStatus2["JOINED"] = "Joined";
  MeetingJoineeStatus2["LEFT"] = "Left";
  return MeetingJoineeStatus2;
})(MeetingJoineeStatus || {});

// src/meeting/meetingRecording.interface.ts
var RecordingStatus = /* @__PURE__ */ ((RecordingStatus2) => {
  RecordingStatus2["INPROGRESS"] = "InProgress";
  RecordingStatus2["UPLOADING"] = "Uploading";
  RecordingStatus2["COMPLETED"] = "Completed";
  return RecordingStatus2;
})(RecordingStatus || {});

// src/prepPlan/prepPlan.interface.ts
var PrepPlanBadgeStatus = /* @__PURE__ */ ((PrepPlanBadgeStatus2) => {
  PrepPlanBadgeStatus2["COMPLETED"] = "completed";
  PrepPlanBadgeStatus2["IN_PROGRESS"] = "inProgress";
  PrepPlanBadgeStatus2["LOCKED"] = "locked";
  return PrepPlanBadgeStatus2;
})(PrepPlanBadgeStatus || {});
var AssessActivityType = /* @__PURE__ */ ((AssessActivityType2) => {
  AssessActivityType2["ShowSolution"] = "ShowSolution";
  AssessActivityType2["ShowHint"] = "ShowHint";
  AssessActivityType2["ShowHints"] = "ShowHints";
  AssessActivityType2["CodeRun"] = "CodeRun";
  return AssessActivityType2;
})(AssessActivityType || {});
var AttemptStatus = /* @__PURE__ */ ((AttemptStatus2) => {
  AttemptStatus2["ATTEMPTED"] = "ATTEMPTED";
  AttemptStatus2["NOT_ATTEMPTED"] = "NOT_ATTEMPTED";
  return AttemptStatus2;
})(AttemptStatus || {});

// src/prepPlan/prepPlanQuestionPerformance.interface.ts
var QuestionDifficulty = /* @__PURE__ */ ((QuestionDifficulty2) => {
  QuestionDifficulty2["Easy"] = "Easy";
  QuestionDifficulty2["Medium"] = "Medium";
  QuestionDifficulty2["Hard"] = "Hard";
  return QuestionDifficulty2;
})(QuestionDifficulty || {});

// src/payment/payment.interface.ts
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["Requested"] = "Requested";
  PaymentStatus2["Success"] = "Success";
  PaymentStatus2["Failed"] = "Failed";
  return PaymentStatus2;
})(PaymentStatus || {});
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["Jap"] = "Jap";
  PaymentType2["Map"] = "Map";
  PaymentType2["Plan"] = "Plan";
  PaymentType2["PrepPlanCompletion"] = "PrepPlanCompletion";
  PaymentType2["InterviewBooking"] = "InterviewBooking";
  PaymentType2["BenchmarkingTest"] = "BenchmarkingTest";
  PaymentType2["Drive"] = "Drive";
  PaymentType2["Assessment"] = "Assessment";
  return PaymentType2;
})(PaymentType || {});

// src/whatsapp/whatsappReminderLog.interface.ts
var WhatsappMessageType = /* @__PURE__ */ ((WhatsappMessageType2) => {
  WhatsappMessageType2["MeetingReminder"] = "MeetingReminder";
  WhatsappMessageType2["ApplicationOpen"] = "ApplicationOpen";
  WhatsappMessageType2["ScreeningRoundCompletion"] = "ScreeningRoundCompletion";
  WhatsappMessageType2["MeetingScheduleAfterScreeningReminder"] = "MeetingScheduleAfterScreeningReminder";
  WhatsappMessageType2["JobSeekerGetsShortlisted"] = "JobSeekerGetsShortlisted";
  WhatsappMessageType2["JobSeekerGetsShortlistedAfterApplying"] = "JobSeekerGetsShortlistedAfterApplying";
  WhatsappMessageType2["JobSeekerMovedToNextRound"] = "JobSeekerMovedToNextRound";
  WhatsappMessageType2["JobSeekerMovedToLastRound"] = "JobSeekerMovedToLastRound";
  WhatsappMessageType2["AssignmentSentToJobSeeker"] = "AssignmentSentToJobSeeker";
  WhatsappMessageType2["InterviewSchdeuledWithJobSeeker"] = "InterviewSchdeuledWithJobSeeker";
  WhatsappMessageType2["MessageSentToJobSeeker"] = "MessageSentToJobSeeker";
  WhatsappMessageType2["OfferLetterSentToJobSeeker"] = "OfferLetterSentToJobSeeker";
  WhatsappMessageType2["NewOpportunityAlert"] = "NewOpportunityAlert";
  WhatsappMessageType2["PositionRecommendationAlert"] = "PositionRecommendationAlert";
  WhatsappMessageType2["NewPositionCreatedByAccountManager"] = "NewPositionCreatedByAccountManager";
  WhatsappMessageType2["TestBookingReminder"] = "TestBookingReminder";
  WhatsappMessageType2["SendOneDayTestRemainder"] = "SendOneDayTestRemainder";
  WhatsappMessageType2["SendThirtyMinutesBeforeOrAfterTestRemainder"] = "SendThirtyMinutesBeforeOrAfterTestRemainder";
  WhatsappMessageType2["SendCounsellingBookingRemainder"] = "SendCounsellingBookingRemainder";
  WhatsappMessageType2["SendTwentyMinutesCounsellingRemainder"] = "SendTwentyMinutesCounsellingRemainder";
  WhatsappMessageType2["ApplicationInactiveReminder"] = "ApplicationInactiveReminder";
  WhatsappMessageType2["ApplicationExpiryReminder"] = "ApplicationExpiryReminder";
  WhatsappMessageType2["ManualRecommendedWhatsappReminder"] = "ManualRecommendedWhatsappReminder";
  WhatsappMessageType2["CandidateRejected"] = "CandidateRejected";
  return WhatsappMessageType2;
})(WhatsappMessageType || {});

// src/whatsapp/whatsappTemplate.interface.ts
var SerriTemplateType = /* @__PURE__ */ ((SerriTemplateType2) => {
  SerriTemplateType2["NEW_POSITION_ALERT"] = "new_position_alert";
  SerriTemplateType2["APPLICATION_INACTIVE"] = "application_inactive";
  SerriTemplateType2["APPLICATION_EXPIRY"] = "application_expiry";
  SerriTemplateType2["SHORTLISTED_AFTER_APPLYING"] = "shortlisted_after_applying";
  SerriTemplateType2["ASSIGNMENT_SENT"] = "assignment_sent";
  SerriTemplateType2["ONLINE_TEST_SENT"] = "online_test_sent";
  SerriTemplateType2["INTERVIEW_SCHEDULED"] = "interview_scheduled";
  SerriTemplateType2["CANDIDATE_REJECTED"] = "candidate_rejected";
  SerriTemplateType2["OFFER_ROLLED_OUT"] = "offer_rolled_out";
  return SerriTemplateType2;
})(SerriTemplateType || {});

// src/reward/reward.interface.ts
var RewardActivityType = /* @__PURE__ */ ((RewardActivityType2) => {
  RewardActivityType2["Practice"] = "Practice";
  RewardActivityType2["Quiz"] = "Quiz";
  RewardActivityType2["Streak"] = "Streak";
  RewardActivityType2["Register"] = "Register";
  RewardActivityType2["ProfileCompletion"] = "ProfileCompletion";
  RewardActivityType2["FirstMeetingCompletion"] = "FirstMeetingCompletion";
  RewardActivityType2["RefereeFirstMeetingCompletion"] = "RefereeFirstMeetingCompletion";
  return RewardActivityType2;
})(RewardActivityType || {});
var RewardType = /* @__PURE__ */ ((RewardType2) => {
  RewardType2["Level"] = "Level";
  RewardType2["LevelCoin"] = "LevelCoin";
  return RewardType2;
})(RewardType || {});

// src/tracking/tracking.interface.ts
var TrackingType = /* @__PURE__ */ ((TrackingType2) => {
  TrackingType2["FLYWHEEL_MAIL_SENT"] = "FLYWHEEL_MAIL_SENT";
  TrackingType2["FLYWHEEL_MAIL_OPENED"] = "FLYWHEEL_MAIL_OPENED";
  TrackingType2["FLYWHEEL_LEAD_LANDED_ON_BOOK_A_DEMO"] = "FLYWHEEL_LEAD_LANDED_ON_BOOK_A_DEMO";
  TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO";
  TrackingType2["FLYWHEEL_LEAD_LANDED_ON_SIGN_IN"] = "FLYWHEEL_LEAD_LANDED_ON_SIGN_IN";
  TrackingType2["RECEIVED_VALID_SCRAPED_LEADS"] = "RECEIVED_VALID_SCRAPED_LEADS";
  TrackingType2["CODE_BLACK_SCRAPE_POSITIONS"] = "CODE_BLACK_SCRAPE_POSITIONS";
  TrackingType2["RECRUITER_SIGNED_UP"] = "RECRUITER_SIGNED_UP";
  TrackingType2["USER_SIGNED_UP"] = "USER_SIGNED_UP";
  TrackingType2["USER_SIGNED_IN"] = "USER_SIGNED_IN";
  TrackingType2["USER_SIGN_IN"] = "USER_SIGN_IN";
  TrackingType2["POSITION_CREATED"] = "POSITION_CREATED";
  TrackingType2["COMPANY_ONBOARDED"] = "COMPANY_ONBOARDED";
  TrackingType2["CANDIDATE_REJECTED"] = "CANDIDATE_REJECTED";
  TrackingType2["RECRUITER_FETCHING_ACC_MANAGER_DETAILS"] = "RECRUITER_FETCHING_ACC_MANAGER_DETAILS";
  TrackingType2["ASSIGMENT_ROLLED_OUT"] = "ASSIGMENT_ROLLED_OUT";
  TrackingType2["OFFER_ROLLED_OUT"] = "OFFER_ROLLED_OUT";
  TrackingType2["INTERVIEW_SCHEDULED"] = "INTERVIEW_SCHEDULED";
  TrackingType2["DOWNLOAD_APPLICANT_DETAILS"] = "DOWNLOAD_APPLICANT_DETAILS";
  TrackingType2["REQUEST_MORE_PROFILES"] = "REQUEST_MORE_PROFILES";
  TrackingType2["CANDIDATE_MOVED_TO_APPLICANT"] = "CANDIDATE_MOVED_TO_APPLICANT";
  TrackingType2["CANDIDATES_PUSHED_IN_POSITION"] = "CANDIDATES_PUSHED_IN_POSITION";
  TrackingType2["CANDIDATE_APPLIED"] = "CANDIDATE_APPLIED";
  TrackingType2["CANDIDATE_SHORTLISTED"] = "CANDIDATE_SHORTLISTED";
  TrackingType2["CANDIDATE_ACCEPTED_OFFER"] = "CANDIDATE_ACCEPTED_OFFER";
  TrackingType2["ROUND_DEADLINE_EXTENDED"] = "ROUND_DEADLINE_EXTENDED";
  TrackingType2["CANDIDATE_NOT_INTERESTED"] = "CANDIDATE_NOT_INTERESTED";
  TrackingType2["CANDIDATE_OPTED_OUT"] = "CANDIDATE_OPTED_OUT";
  TrackingType2["ACTIVE_COMPANIES_ON_LEVELUP"] = "ACTIVE_COMPANIES_ON_LEVELUP";
  TrackingType2["ASSIGNMENT_APPROVED"] = "ASSIGNMENT_APPROVED";
  TrackingType2["SCHEDULED_HUMAN_INTERVIEW"] = "SCHEDULED_HUMAN_INTERVIEW";
  TrackingType2["SCHEDULED_AI_INTERVIEW"] = "SCHEDULED_AI_INTERVIEW";
  TrackingType2["STARTED_AI_INTERVIEW"] = "STARTED_AI_INTERVIEW";
  TrackingType2["STARTED_HUMAN_INTERVIEW"] = "STARTED_HUMAN_INTERVIEW";
  TrackingType2["COMPLETED_AI_INTERVIEW"] = "COMPLETED_AI_INTERVIEW";
  TrackingType2["COMPLETED_HUMAN_INTERVIEW"] = "COMPLETED_HUMAN_INTERVIEW";
  TrackingType2["QUALIFIED_FOR_MDP"] = "QUALIFIED_FOR_MDP";
  TrackingType2["VISITED_ALUM_PAGE"] = "VISITED_ALUM_PAGE";
  TrackingType2["OPENED_ALUM_DRAWER"] = "OPENED_ALUM_DRAWER";
  TrackingType2["SCHEDULED_ALUM_CONNECT"] = "SCHEDULED_ALUM_CONNECT";
  TrackingType2["MENTOR_CONNECT_SCHEDULED"] = "MENTOR_CONNECT_SCHEDULED";
  TrackingType2["MENTOR_CONNECT_COMPLETED"] = "MENTOR_CONNECT_COMPLETED";
  TrackingType2["COMPLETED_ALUM_CONNECT"] = "COMPLETED_ALUM_CONNECT";
  TrackingType2["VISITED_ONWARDS_JOBS_PAGE"] = "VISITED_ONWARDS_JOBS_PAGE";
  TrackingType2["CLICKED_TAKE_INTERVIEW_ONWARDS"] = "CLICKED_TAKE_INTERVIEW_ONWARDS";
  TrackingType2["BRIEF_DEBRIEF_CALL"] = "BRIEF_DEBRIEF_CALL";
  TrackingType2["CONTEST_PARTICIPATE"] = "CONTEST_PARTICIPATE";
  TrackingType2["CONTEST_REGISTERED"] = "CONTEST_REGISTERED";
  TrackingType2["CONTEST_VIEW_RESULTES"] = "CONTEST_VIEW_RESULTES";
  TrackingType2["OPENED_MENTOR_DRAWER"] = "OPENED_MENTOR_DRAWER";
  TrackingType2["CHALLENGE_STARTED"] = "CHALLENGE_STARTED";
  TrackingType2["CHALLENGE_QUESTION_COMPLETED"] = "CHALLENGE_QUESTION_COMPLETED";
  TrackingType2["CHALLENGE_QUESTION_SUBMITTED"] = "CHALLENGE_QUESTION_SUBMITTED";
  TrackingType2["USER_REGISTERED"] = "USER_REGISTERED";
  TrackingType2["RECRUITER_INVITED"] = "RECRUITER_INVITED";
  TrackingType2["RECRUITER_INVITED_ON_POSITION"] = "RECRUITER_INVITED_ON_POSITION";
  TrackingType2["CLICKED_BOOK_A_DEMO_SIGN_UP"] = "CLICKED_BOOK_A_DEMO_SIGN_UP";
  TrackingType2["FLYWHEEL_LANDED_ON_CANDIDATE_PROFILE_PAGE"] = "FLYWHEEL_LANDED_ON_CANDIDATE_PROFILE_PAGE";
  TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO_BANNER"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO_BANNER";
  TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO_ON_MODAL"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO_ON_MODAL";
  TrackingType2["FLYWHEEL_CLICKED_ON_VIEW_PROFILE"] = "FLYWHEEL_CLICKED_ON_VIEW_PROFILE";
  TrackingType2["FLYWHEEL_CLICKED_ON_SHORTLIST"] = "FLYWHEEL_CLICKED_ON_SHORTLIST";
  TrackingType2["FLYWHEEL_CLICKED_ON_JD"] = "FLYWHEEL_CLICKED_ON_JD";
  TrackingType2["SCHEDULED_ASSESSMENT"] = "SCHEDULED_ASSESSMENT";
  TrackingType2["STARTED_ASSESSMENT"] = "STARTED_ASSESSMENT";
  TrackingType2["RESET_LEVEL"] = "RESET_LEVEL";
  TrackingType2["COPY_HIRING_ASSESSMENT_LINK"] = "COPY_HIRING_ASSESSMENT_LINK";
  TrackingType2["COPY_HIRING_ASSESSMENT_MESSAGE"] = "COPY_HIRING_ASSESSMENT_MESSAGE";
  return TrackingType2;
})(TrackingType || {});
var UITrackingType = /* @__PURE__ */ ((UITrackingType2) => {
  UITrackingType2["COMPANY_ONBOARDED"] = "COMPANY_ONBOARDED";
  UITrackingType2["POSITION_CREATED"] = "POSITION_CREATED";
  UITrackingType2["RECRUITER_SIGNED_UP"] = "RECRUITER_SIGNED_UP";
  UITrackingType2["CANDIDATE_MOVED_TO_APPLICANT"] = "CANDIDATE_MOVED_TO_APPLICANT";
  UITrackingType2["CANDIDATES_PUSHED_IN_POSITION"] = "CANDIDATES_PUSHED_IN_POSITION";
  UITrackingType2["CANDIDATE_APPLIED"] = "CANDIDATE_APPLIED";
  UITrackingType2["CANDIDATE_SHORTLISTED"] = "CANDIDATE_SHORTLISTED";
  UITrackingType2["ACTIVE_COMPANIES_ON_LEVELUP"] = "ACTIVE_COMPANIES_ON_LEVELUP";
  UITrackingType2["CONTEST_PARTICIPATE"] = "CONTEST_PARTICIPATE";
  UITrackingType2["CONTEST_REGISTERED"] = "CONTEST_REGISTERED";
  UITrackingType2["CONTEST_VIEW_RESULTES"] = "CONTEST_VIEW_RESULTES";
  return UITrackingType2;
})(UITrackingType || {});
var TrackingContent = /* @__PURE__ */ ((TrackingContent2) => {
  TrackingContent2["CONTEST"] = "CONTEST";
  return TrackingContent2;
})(TrackingContent || {});

// src/session/sessionLogs.interface.ts
var SessionJoineeStatus = /* @__PURE__ */ ((SessionJoineeStatus2) => {
  SessionJoineeStatus2["JOINED"] = "Joined";
  SessionJoineeStatus2["LEFT"] = "Left";
  return SessionJoineeStatus2;
})(SessionJoineeStatus || {});

// src/session/session.interface.ts
var SessionStatus = /* @__PURE__ */ ((SessionStatus2) => {
  SessionStatus2["SCHEDULED"] = "Scheduled";
  SessionStatus2["STARTED"] = "Started";
  SessionStatus2["COMPLETED"] = "Completed";
  SessionStatus2["CANCELLED"] = "Cancelled";
  SessionStatus2["RESCHEDULED"] = "Rescheduled";
  SessionStatus2["ERRORED"] = "Errored";
  SessionStatus2["MENTORCANCELLED"] = "HostCancelled";
  SessionStatus2["PARTICIPANTCANCELLED"] = "ParticipantCancelled";
  SessionStatus2["ADMINCANCELLED"] = "AdminCancelled";
  SessionStatus2["HOSTRESCHEDULED"] = "HostRescheduled";
  SessionStatus2["ADMINRESCHEDULED"] = "AdminRescheduled";
  SessionStatus2["PARTICIPANTRESCHEDULED"] = "ParticipantRescheduled";
  SessionStatus2["PARTICIPANTNOSHOW"] = "ParticipantNoShow";
  SessionStatus2["HOSTNOSHOW"] = "HostNoShow";
  return SessionStatus2;
})(SessionStatus || {});
var SessionSuccessStatus = /* @__PURE__ */ ((SessionSuccessStatus2) => {
  SessionSuccessStatus2["SUCCESSFUL"] = "Successful";
  SessionSuccessStatus2["PARTIALLYSUCCESSFUL"] = "PartiallySuccessful";
  SessionSuccessStatus2["UNSUCCESSFUL"] = "Unsuccessful";
  return SessionSuccessStatus2;
})(SessionSuccessStatus || {});
var SessionType = /* @__PURE__ */ ((SessionType2) => {
  SessionType2["MENTOR_SESSION"] = "Mentor_Session";
  SessionType2["ALUMNI_SESSION"] = "Alumni_Session";
  return SessionType2;
})(SessionType || {});

// src/session/sessionRecording.interface.ts
var SessionRecordingStatus = /* @__PURE__ */ ((SessionRecordingStatus2) => {
  SessionRecordingStatus2["INPROGRESS"] = "InProgress";
  SessionRecordingStatus2["UPLOADING"] = "Uploading";
  SessionRecordingStatus2["COMPLETED"] = "Completed";
  return SessionRecordingStatus2;
})(SessionRecordingStatus || {});

// src/contest/contestTemplate.interface.ts
var ContestRewardTypes = /* @__PURE__ */ ((ContestRewardTypes2) => {
  ContestRewardTypes2["MONEY"] = "money";
  ContestRewardTypes2["LEVELUP_COINS"] = "levelup_coins";
  return ContestRewardTypes2;
})(ContestRewardTypes || {});

// src/contest/contest.interface.ts
var ContestStatus = /* @__PURE__ */ ((ContestStatus2) => {
  ContestStatus2["REGISTERED"] = "registered";
  ContestStatus2["STARTED"] = "started";
  ContestStatus2["JOINED"] = "joined";
  ContestStatus2["ENDED"] = "ended";
  ContestStatus2["GRADED"] = "graded";
  return ContestStatus2;
})(ContestStatus || {});

// src/nbfcDetails/nbfcDetails.interface.ts
var NbfcDetailStatus = /* @__PURE__ */ ((NbfcDetailStatus2) => {
  NbfcDetailStatus2["DISBURSAL_DONE"] = "disbursal-done";
  NbfcDetailStatus2["ADDED_TO_AUDIT"] = "added-to-audit";
  NbfcDetailStatus2["DISBURSAL_PENDING"] = "disbursal-pending";
  NbfcDetailStatus2["DISBURSAL_NOT_NEEDED"] = "disbursal-not-needed";
  NbfcDetailStatus2["STUDENT_NOT_COMPLYING"] = "student-not-complying";
  NbfcDetailStatus2["FORCLOSED"] = "forclosed";
  NbfcDetailStatus2["MORAT_DISBURSAL_PENDING"] = "morat-disbursal-pending";
  NbfcDetailStatus2["FORECLOSED_ADDED_TO_AUDIT"] = "foreclosed-added-to-audit";
  NbfcDetailStatus2["FORECLOSED_STUDENT_NOT_COMPLYING"] = "foreclosed-student-not-complying";
  NbfcDetailStatus2["FORECLOSED_MORAT_DISBURSAL_PENDING"] = "foreclosed-morat-disbursal-pending";
  NbfcDetailStatus2["DISBURSAL_DONE_CFRS"] = "disbursal-done-cfrs";
  return NbfcDetailStatus2;
})(NbfcDetailStatus || {});

// src/slack/slack.interface.ts
var SlackWorkspaceType = /* @__PURE__ */ ((SlackWorkspaceType2) => {
  SlackWorkspaceType2["MASAI_SCHOOL"] = "MASAI_SCHOOL";
  SlackWorkspaceType2["PLACEMENT_MASTER"] = "PLACEMENT_MASTER";
  return SlackWorkspaceType2;
})(SlackWorkspaceType || {});
var SlackMessageHistoryStatusEnums = /* @__PURE__ */ ((SlackMessageHistoryStatusEnums2) => {
  SlackMessageHistoryStatusEnums2["SUCCESS"] = "success";
  SlackMessageHistoryStatusEnums2["FAILED"] = "failed";
  return SlackMessageHistoryStatusEnums2;
})(SlackMessageHistoryStatusEnums || {});
var SlackMessageHistoryErrorEnums = /* @__PURE__ */ ((SlackMessageHistoryErrorEnums2) => {
  SlackMessageHistoryErrorEnums2["DELETED"] = "Deleted";
  SlackMessageHistoryErrorEnums2["TIME_IN_PAST"] = "time_in_past";
  SlackMessageHistoryErrorEnums2["TIME_TOO_FAR"] = "time_too_far";
  SlackMessageHistoryErrorEnums2["ALREADY_SENT_IN_PAST"] = "already_sent_in_past";
  return SlackMessageHistoryErrorEnums2;
})(SlackMessageHistoryErrorEnums || {});
var SlackMessageTypeEnums = /* @__PURE__ */ ((SlackMessageTypeEnums2) => {
  SlackMessageTypeEnums2["SCHEDULE"] = "schedule";
  SlackMessageTypeEnums2["INSTANT"] = "instant";
  return SlackMessageTypeEnums2;
})(SlackMessageTypeEnums || {});

// src/slack/slackWorkspace.interface.ts
var SlackWorkspaceEnvironment = /* @__PURE__ */ ((SlackWorkspaceEnvironment2) => {
  SlackWorkspaceEnvironment2["DEVELOPMENT"] = "development";
  SlackWorkspaceEnvironment2["PRODUCTION"] = "production";
  return SlackWorkspaceEnvironment2;
})(SlackWorkspaceEnvironment || {});

// src/pifReview/pifReview.interface.ts
var PIFReviewStatusType = /* @__PURE__ */ ((PIFReviewStatusType2) => {
  PIFReviewStatusType2["NotApproved"] = "NotApproved";
  PIFReviewStatusType2["Approved"] = "Approved";
  return PIFReviewStatusType2;
})(PIFReviewStatusType || {});

// src/campusApplication/campusApplication.interface.ts
var CampusApplicationStatus = /* @__PURE__ */ ((CampusApplicationStatus2) => {
  CampusApplicationStatus2["SHORTLISTED"] = "shortlisted";
  CampusApplicationStatus2["REJECTED"] = "rejected";
  CampusApplicationStatus2["HIRED"] = "hired";
  return CampusApplicationStatus2;
})(CampusApplicationStatus || {});
var matchedPercentileType = /* @__PURE__ */ ((matchedPercentileType2) => {
  matchedPercentileType2["EXCELLENT"] = "excellent";
  matchedPercentileType2["GOOD"] = "good";
  matchedPercentileType2["MODERATE"] = "moderate";
  matchedPercentileType2["LOW"] = "low";
  return matchedPercentileType2;
})(matchedPercentileType || {});
var CampusRoundStatus = /* @__PURE__ */ ((CampusRoundStatus2) => {
  CampusRoundStatus2["STARTED"] = "started";
  CampusRoundStatus2["COMPLETED"] = "completed";
  CampusRoundStatus2["CLOSED"] = "closed";
  CampusRoundStatus2["CANCELLED"] = "cancelled";
  return CampusRoundStatus2;
})(CampusRoundStatus || {});
var CampusRoundType = /* @__PURE__ */ ((CampusRoundType2) => {
  CampusRoundType2["INTERVIEW"] = "interview";
  return CampusRoundType2;
})(CampusRoundType || {});

// src/drive/drive.interface.ts
var OfflineDocumentsTypes = /* @__PURE__ */ ((OfflineDocumentsTypes2) => {
  OfflineDocumentsTypes2["AADHAR_CARD"] = "aadhar_card";
  OfflineDocumentsTypes2["LAPTOP"] = "laptop";
  OfflineDocumentsTypes2["RESUME"] = "resume";
  return OfflineDocumentsTypes2;
})(OfflineDocumentsTypes || {});

// src/drive/driveInvitees.interface.ts
var DriveInviteeStatus = /* @__PURE__ */ ((DriveInviteeStatus2) => {
  DriveInviteeStatus2["PENDING"] = "pending";
  DriveInviteeStatus2["ACCEPT"] = "accept";
  DriveInviteeStatus2["REJECT"] = "reject";
  DriveInviteeStatus2["REGISTER"] = "register";
  return DriveInviteeStatus2;
})(DriveInviteeStatus || {});
var DriveRoundType = /* @__PURE__ */ ((DriveRoundType2) => {
  DriveRoundType2["ASSIGNMENT"] = "assignment";
  DriveRoundType2["INTERVIEW"] = "interview";
  DriveRoundType2["FINAL_ROUND"] = "final_round";
  return DriveRoundType2;
})(DriveRoundType || {});
var OfflineTechStackType = /* @__PURE__ */ ((OfflineTechStackType2) => {
  OfflineTechStackType2["FRONTEND"] = "Frontend";
  OfflineTechStackType2["BACKEND"] = "Backend";
  OfflineTechStackType2["FULLSTACK"] = "Fullstack";
  OfflineTechStackType2["QualityAnalysis"] = "Quality Analysis";
  OfflineTechStackType2["DataAnalysis"] = "Data Analysis";
  return OfflineTechStackType2;
})(OfflineTechStackType || {});
var JobseekerFormJobType = /* @__PURE__ */ ((JobseekerFormJobType2) => {
  JobseekerFormJobType2["TECH_JOBS"] = "Tech_Jobs";
  JobseekerFormJobType2["NON_TECH_JOBS"] = "Non_Tech_Jobs";
  return JobseekerFormJobType2;
})(JobseekerFormJobType || {});
var DriveInviteeType = /* @__PURE__ */ ((DriveInviteeType2) => {
  DriveInviteeType2["JOBSEEKER"] = "JobSeeker";
  DriveInviteeType2["RECRUITER"] = "Recruiter";
  DriveInviteeType2["COMPANY"] = "Company";
  return DriveInviteeType2;
})(DriveInviteeType || {});
var DriveInviteeApplicationStatus = /* @__PURE__ */ ((DriveInviteeApplicationStatus2) => {
  DriveInviteeApplicationStatus2["PENDING_PAYMENT"] = "pending_payment";
  DriveInviteeApplicationStatus2["PAYMENT_FAILED"] = "payment_failed";
  DriveInviteeApplicationStatus2["PAYMENT_SUCCESS"] = "payment_success";
  DriveInviteeApplicationStatus2["ASSESSMENT"] = "assessment";
  DriveInviteeApplicationStatus2["ASSESSMENT_PENDING_RESULTS"] = "assessment_pending_results";
  DriveInviteeApplicationStatus2["ASSESSMENT_FAILED"] = "assessment_failed";
  DriveInviteeApplicationStatus2["COUNSELLING"] = "counseling";
  DriveInviteeApplicationStatus2["COUNSELLING_PENDING_RESULTS"] = "counseling_pending_results";
  DriveInviteeApplicationStatus2["COUNSELLING_FAILED"] = "counseling_failed";
  DriveInviteeApplicationStatus2["PENDING_FINAL_PAYMENT"] = "pending_final_payment";
  DriveInviteeApplicationStatus2["FINAL_PAYMENT_FAILED"] = "final_payment_failed";
  DriveInviteeApplicationStatus2["ACCEPT"] = "accept";
  DriveInviteeApplicationStatus2["REJECT"] = "reject";
  return DriveInviteeApplicationStatus2;
})(DriveInviteeApplicationStatus || {});
var DriveInviteeTestStatusType = /* @__PURE__ */ ((DriveInviteeTestStatusType2) => {
  DriveInviteeTestStatusType2["PENDING"] = "PENDING";
  DriveInviteeTestStatusType2["COMPLETED"] = "COMPLETED";
  DriveInviteeTestStatusType2["ENDED"] = "ENDED";
  return DriveInviteeTestStatusType2;
})(DriveInviteeTestStatusType || {});
var OfflineDriveCandidateStatus = /* @__PURE__ */ ((OfflineDriveCandidateStatus2) => {
  OfflineDriveCandidateStatus2["ATTENDANCE_NOT_MARKED"] = "attendance_not_marked";
  OfflineDriveCandidateStatus2["BUSY"] = "busy";
  OfflineDriveCandidateStatus2["IDLE"] = "idle";
  OfflineDriveCandidateStatus2["HIRED"] = "hired";
  OfflineDriveCandidateStatus2["PRESENT"] = "present";
  OfflineDriveCandidateStatus2["ASSIGN"] = "assign";
  OfflineDriveCandidateStatus2["OUT_OF_DRIVE"] = "out_of_drive";
  return OfflineDriveCandidateStatus2;
})(OfflineDriveCandidateStatus || {});

// src/offlineDriveRoom/offlineDriveRoom.interface.ts
var OFFLINE_DRIVE_CITY = /* @__PURE__ */ ((OFFLINE_DRIVE_CITY2) => {
  OFFLINE_DRIVE_CITY2["BANGALORE"] = "bangalore";
  OFFLINE_DRIVE_CITY2["MUMBAI"] = "mumbai";
  OFFLINE_DRIVE_CITY2["NEW_DELHI"] = "new-delhi";
  OFFLINE_DRIVE_CITY2["CHENNAI"] = "chennai";
  OFFLINE_DRIVE_CITY2["KOLKATA"] = "kolkata";
  OFFLINE_DRIVE_CITY2["HYDERABAD"] = "hyderabad";
  OFFLINE_DRIVE_CITY2["PUNE"] = "pune";
  OFFLINE_DRIVE_CITY2["CHANDIGARH"] = "chandigarh";
  OFFLINE_DRIVE_CITY2["NOIDA"] = "noida";
  OFFLINE_DRIVE_CITY2["GURGAON"] = "gurgaon";
  OFFLINE_DRIVE_CITY2["JAIPUR"] = "jaipur";
  OFFLINE_DRIVE_CITY2["DEHRADUN"] = "dehradun";
  OFFLINE_DRIVE_CITY2["DELHINCR"] = "delhincr";
  OFFLINE_DRIVE_CITY2["Hosur"] = "hosur";
  return OFFLINE_DRIVE_CITY2;
})(OFFLINE_DRIVE_CITY || {});

// src/leadGen/leadGen.interface.ts
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["New"] = "New";
  Status2["NotConnected"] = "Not Connected";
  Status2["DNP"] = "DNP";
  Status2["Positive"] = "Positive";
  Status2["FutureProspect"] = "Future Prospect";
  Status2["Qualified"] = "Qualified";
  Status2["Unqualified"] = "Unqualified";
  Status2["NotHiring"] = "Not Hiring";
  return Status2;
})(Status || {});
var CallLogsDispositions = /* @__PURE__ */ ((CallLogsDispositions2) => {
  CallLogsDispositions2["AllLeadsNewByDefault"] = "All leads new by default";
  CallLogsDispositions2["NoPOC"] = "No POC";
  CallLogsDispositions2["POCNumberNotFound"] = "POC Number not found";
  CallLogsDispositions2["NoIncoming"] = "No Incoming";
  CallLogsDispositions2["IncorrectNumber"] = "Incorrect Number";
  CallLogsDispositions2["NotRightPOC"] = "Not right POC";
  CallLogsDispositions2["DNP1"] = "DNP 1";
  CallLogsDispositions2["DNP2"] = "DNP 2";
  CallLogsDispositions2["Busy"] = "Busy";
  CallLogsDispositions2["Hiring"] = "Hiring";
  CallLogsDispositions2["NotHiring"] = "Not Hiring";
  CallLogsDispositions2["CallBackLater"] = "Call Back later";
  CallLogsDispositions2["WillDiscussAndBack"] = "Will discuss and back";
  CallLogsDispositions2["WillHireLater"] = "Will Hire Later";
  CallLogsDispositions2["PositionClosed"] = "Position Closed";
  CallLogsDispositions2["Qualified"] = "Qualified";
  CallLogsDispositions2["DNP3"] = "DNP 3";
  CallLogsDispositions2["NotHiringExternally"] = "Not Hiring Externally";
  CallLogsDispositions2["TechStackMismatch"] = "Tech Stack Mismatch";
  CallLogsDispositions2["Consultancy"] = "Consultancy";
  CallLogsDispositions2["LowCTC"] = "Low CTC";
  CallLogsDispositions2["ExperienceMismatch"] = "Experience Mismatch";
  CallLogsDispositions2["Employees1000Plus"] = "1000+ Employees";
  CallLogsDispositions2["JunkLead"] = "Junk Lead";
  return CallLogsDispositions2;
})(CallLogsDispositions || {});
var Source = /* @__PURE__ */ ((Source2) => {
  Source2["WebsiteGeneric"] = "Website Generic";
  Source2["JobPortals"] = "Job Portals";
  Source2["Referral"] = "Referral";
  Source2["MassMailers"] = "Mass Mailers";
  Source2["LinkedInAds"] = "LinkedIn Ads";
  Source2["InshortsAds"] = "Inshorts Ads";
  Source2["GoogleAds"] = "Google Ads";
  Source2["TalentCircle"] = "Talent Circle";
  Source2["OtherMarketingCampaigns"] = "Other Marketing Campaigns";
  Source2["Hubspot"] = "Hubspot";
  Source2["SelfSourced"] = "Self Sourced";
  return Source2;
})(Source || {});

// src/nonMasaiPlacementDrive/applicationFormDetails.interface.ts
var HighestQualification = /* @__PURE__ */ ((HighestQualification2) => {
  HighestQualification2["TWELVE_PASS_OR_DIPLOMA"] = "12th_pass_or_diploma";
  HighestQualification2["UNDERGRADUATE"] = "undergraduate";
  HighestQualification2["GRADUATE"] = "graduate";
  return HighestQualification2;
})(HighestQualification || {});

// src/support/support.interface.ts
var SupportQuestionCategory = /* @__PURE__ */ ((SupportQuestionCategory2) => {
  SupportQuestionCategory2["GENERAL"] = "general";
  SupportQuestionCategory2["COMPANY"] = "company";
  return SupportQuestionCategory2;
})(SupportQuestionCategory || {});
var SupportTicketStatus = /* @__PURE__ */ ((SupportTicketStatus2) => {
  SupportTicketStatus2["OPEN"] = "open";
  SupportTicketStatus2["RESOLVED"] = "resolved";
  return SupportTicketStatus2;
})(SupportTicketStatus || {});
var EscalationLevel = /* @__PURE__ */ ((EscalationLevel2) => {
  EscalationLevel2["L1"] = "L1";
  EscalationLevel2["L2"] = "L2";
  EscalationLevel2["L3"] = "L3";
  EscalationLevel2["L4"] = "L4";
  return EscalationLevel2;
})(EscalationLevel || {});
var MessageSenderType = /* @__PURE__ */ ((MessageSenderType2) => {
  MessageSenderType2["USER"] = "user";
  MessageSenderType2["ASSIGN"] = "assign";
  MessageSenderType2["AGENT"] = "agent";
  MessageSenderType2["SYSTEM"] = "system";
  return MessageSenderType2;
})(MessageSenderType || {});
var VoteType = /* @__PURE__ */ ((VoteType2) => {
  VoteType2["UPVOTE"] = "upvote";
  VoteType2["DOWNVOTE"] = "downvote";
  return VoteType2;
})(VoteType || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AccountManagerType,
  ApplicationChatMode,
  ApplicationReminderType,
  ApplicationRoundStatus,
  ApplicationRoundType,
  ApplicationStatus,
  ApprovalType,
  AssessActivityType,
  AssessPlatformDifficulty,
  AssessmentDuration,
  AssignmentSubmissionType,
  AttemptStatus,
  AvailedInterviewType,
  BehaviouralFlagStatus,
  BriedDebriefCallType,
  CallLogsDispositions,
  CampusApplicationStatus,
  CampusRoundStatus,
  CampusRoundType,
  CompanyNature,
  CompanyOwnershipType,
  CompanyType,
  ContestRewardTypes,
  ContestStatus,
  CourseType,
  CurrentWorkingStatus,
  DegreeType,
  DevelopmentRoleType,
  DriveInviteeApplicationStatus,
  DriveInviteeStatus,
  DriveInviteeTestStatusType,
  DriveInviteeType,
  DriveRoundType,
  EscalationLevel,
  FeatureFlagType,
  GaugingCandidateStatus,
  GradeType,
  HighestQualification,
  InterviewFormatType,
  InterviewPathType,
  JobseekerFormJobType,
  JobseekerSubRole,
  LMSLinkingStatus,
  MarketingPageStatus,
  MeetingJoineeStatus,
  MeetingStatus,
  MeetingSuccessStatus,
  MeetingType,
  MessageSenderType,
  NatureOfBusinessType,
  NbfcDetailStatus,
  OFFLINE_DRIVE_CITY,
  OfflineDocumentsTypes,
  OfflineDriveCandidateStatus,
  OfflineTechStackType,
  OptOutReason,
  PIFReviewStatusType,
  PaymentStatus,
  PaymentType,
  PhoneVerificationStatus,
  PositionBucketType,
  PositionEducationRequirementType,
  PositionQualifiedFor,
  PositionStatus,
  PositionTitle,
  PositionType,
  PositionUserBehaviouralFlag,
  PostgraduateDegreeTypes,
  PrepPlanBadgeStatus,
  ProctoringStatus,
  ProfilePageTabs,
  QuestionDifficulty,
  QuestionTypes,
  Reason,
  RecommendedPath,
  RecordingStatus,
  RewardActivityType,
  RewardType,
  RoundLabelType,
  RoundType,
  ScoreType,
  ScreeningStatus,
  SerriTemplateType,
  SessionJoineeStatus,
  SessionRecordingStatus,
  SessionStatus,
  SessionSuccessStatus,
  SessionType,
  SkillGroupType,
  SkillPriority,
  SkillType,
  SlackMessageHistoryErrorEnums,
  SlackMessageHistoryStatusEnums,
  SlackMessageTypeEnums,
  SlackWorkspaceEnvironment,
  SlackWorkspaceType,
  Source,
  SpecializationType,
  StateCityTypes,
  StateFilterType,
  Status,
  SubRoundType,
  SupportQuestionCategory,
  SupportTicketStatus,
  TechStackType,
  TechStacksForPosition,
  TierType,
  TrackingContent,
  TrackingType,
  TypeOfUsers,
  UIApplicationCardState,
  UIApplicationTypeEnum,
  UIPositionStatus,
  UIRemarksDrawerType,
  UITrackingType,
  UndergraduateDegreeTypes,
  UserCareerPathType,
  UserExperienceLevelType,
  UserISAStatus,
  UserJapEnrollmentStatus,
  UserJapEnrollmentType,
  UserPapStatus,
  UserPercentileBucket,
  UserPlacementTags,
  UserRole,
  VerificationType,
  VisibilityType,
  VoteType,
  WeekDay,
  WhatsappMessageType,
  WorkingMode,
  YesOrNoEnum,
  matchedPercentileType,
  skillsWeightageParameters
});
